<template>
  <div>
    <div id="tabMembers">
      <div class="mx-28 my-32">
        <div>
          <div
            v-if="
              Object.keys(this.checked).filter((k) => this.checked[k] === true)
                .length == 0
            "
            class="flex-row-center height-bind"
          >
            <div class="flex-center fs-24 fc-000000">
              <span class="fw-900">
                {{
                  results.length > 0
                    ? $utils("addCommasInNumber", results.length)
                    : 0
                }}
              </span>
              <span class="fw-700">&nbsp;{{ $t("members.Members") }}</span>
              <span
                v-if="
                  incomplete.length > 1 ||
                  (incomplete.length == 1 &&
                    incomplete[0].user_type !== 'superleader' &&
                    incomplete[0].user_type !== 'superadmin' &&
                    incomplete[0].user_type !== 'leadership' &&
                    (incomplete[0].boss == '' || incomplete[0].team == ''))
                "
                class="fs-14 fw-400 fc-F44336 ml-12"
              >
                <span class="fs-14 fw-400 fc-F44336 ml-12"
                  >⚠️
                  {{
                    Object.keys(incomplete).filter(
                      (k) =>
                        incomplete[k].boss === "" &&
                        (incomplete[k].user_type === "superleader" ||
                          incomplete[k].user_type === "superadmin" ||
                          incomplete[k].user_type === "leadership")
                    ).length == 1
                      ? incomplete.length - 1
                      : incomplete.length
                  }}
                  {{ $t("members.incomplete_profiles") }}</span
                >
              </span>
            </div>

            <div
              style="
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
              "
            >
              <span class="text-archived">
                <span
                  @click="archivedModalClick"
                >
                  {{ $t("members.Archived") }}
                  <span v-if="archivedSchedule > 0">
                    {{ `(${archivedSchedule} Scheduled)` }}
                  </span>
                </span>
              </span>

              <el-button
                class="btnAddMember"
                size="small"
                icon="el-icon-plus"
                @click="addMember"
                >{{ $t("members.ADD_MEMBER") }}</el-button
              >
              <el-badge
                v-if="reviewUpdatesTotal"
                :value="reviewUpdatesTotal" :max="99" class="happily-primary el-badge-unread" style="margin-left: 12px">
                <el-button
                    class="btnExportAll"
                    size="small"
                    @click="clickReviewUpdates"
                    >{{ $t("members.REVIEW_UPDATES") }}</el-button
                  >
              </el-badge>
              <el-button v-else
                    class="btnExportAll"
                    size="small"
                    >{{ $t("members.REVIEW_UPDATES") }}</el-button
                  >
              <download-csv :data="dataexport" style="margin-left: 12px">
                <el-button
                  class="btnExportAll"
                  size="small"
                  @click="clickExport"
                  >{{ $t("members.EXPORT_ALL") }}</el-button
                >
              </download-csv>
              <download-progress :active="showSnackbar"></download-progress>
            </div>
          </div>

          <div
            v-else
            class="flex-row-center height-bind selectionmenu"
            style="background-color: #6c30cc; margin: -10px -40px 0"
          >
            <span class="fs-18 fc-FFFFFF fw-700 ml-40"
              >{{
                $utils(
                  "addCommasInNumber",
                  Object.keys(this.checked).filter(
                    (k) => this.checked[k] === true
                  ).length
                )
              }}
              {{ $t("members.members_selected") }}</span
            >
            <div style="margin-left: 24px; display: flex">
              <div v-for="(item, index) in this.checkedData" :key="index">
                <div v-if="index < 3" style="height: 32px">
                  <img
                    v-if="item.pic"
                    :src="item.pic"
                    class="viewMember image-skeleton image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  />
                  <div
                    v-else
                    class="viewMember image image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  >
                    <div class="text-in-image text-in-image-32 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <span
              v-if="this.checkedData.length > 3"
              class="fs-14 fc-FFFFFF"
              style="margin-left: -10px"
              >+{{
                this.checkedData && this.checkedData.length > 3
                  ? this.checkedData.length - 3
                  : ""
              }}</span
            >

            <div class="divActionHeader">
              <div
                @click.prevent="
                  assignManagerModalStatus = !assignManagerModalStatus
                "
                @click="assignManagerModalClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.RE_ASSIGN_MANAGER") }}
              </div>
              <div
                @click.prevent="assignTeamModalStatus = !assignTeamModalStatus"
                @click="assignTeamModalClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.EDIT_TEAM") }}
              </div>
              <div
                @click="archiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.ARCHIVE") }}
              </div>
              <div
                @click="inviteArrMember"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.SEND_INVITE") }}
              </div>
            </div>
          </div>

          <div class="flex-row-between mt-14">
            <el-input
              class="input-style"
              style="height: 40px"
              autosize
              :placeholder="$t('members.Search')"
              v-model="inputSearch"
              clearable
            ></el-input>

            <div style="width: 220px">
              <el-menu class="input-select" mode="horizontal">
                <el-submenu index="0" style="width: 220px">
                  <template slot="title">
                    <span class="text-dropdown" id="userStatus"
                      >{{ $t("members.All") }}
                      {{
                        datamembers["membersall"]
                          ? "(" + datamembers["membersall"].length + ")"
                          : ""
                      }}</span
                    >
                  </template>
                  <!--<el-menu-item index="1" style="font-size: 14px;width: 220px;">&nbsp;All (162)</el-menu-item> -->
                  <el-menu-item
                    @click="statusClick('new')"
                    index="1"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.New") }}
                    {{
                      this.datamembers["membersnew"]
                        ? "(" + this.datamembers["membersnew"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('invited')"
                    index="2"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.Invited") }}
                    {{
                      this.datamembers["membersinvited"]
                        ? "(" + this.datamembers["membersinvited"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('active')"
                    index="3"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.Active") }}
                    {{
                      this.datamembers["membersact"]
                        ? "(" + this.datamembers["membersact"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('inactive')"
                    index="4"
                    style="font-size: 14px; width: 220px"
                    >Inactive
                    {{
                      this.datamembers["membersinact"]
                        ? "(" + this.datamembers["membersinact"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('all')"
                    index="5"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.All") }}
                    {{
                      datamembers["membersall"]
                        ? "(" + datamembers["membersall"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <div class="mt-20">
            <el-table
              ref="multipleTable"
              :data="members"
              style="width: 100%"
              @sort-change="sort"
              @row-click="rowClickEdit"
              :row-style="tableRowStyle"
              :empty-text="
                loadingMemberTable
                  ? ' '
                  : !loadingMemberTable && inputSearch === ''
                  ? 'No members'
                  : 'No results found...'
              "
            >
              <el-table-column
                :render-header="renderOptionSelect"
                column-key="memberCheckbox"
                width="51"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                    v-model="checked['key_' + scope.row.key]"
                    :key="scope.row.key"
                    @change="membersChecked(scope.row.key)"
                  />
                </template>
              </el-table-column>

              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: scope.row.firstname,
                            lastName: scope.row.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="name"
                sortable="custom"
                :label="$t('members.Member')"
                width="184"
              >
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span 
                    :class="[ blurMode ?  'blurelement': '', 'text-name' ]"

                      >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                    >
                    <span
                    :class="[ blurMode ?  'blurelement': '', 'text-email' ]"
                    >{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="team_name"
                sortable="custom"
                property="team"
                :label="$t('members.Team')"
                width="160"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.team_name"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  >{{scope.row.team_name}}
                    </span>
                  <span v-else class="fc-32C2D5 fs-14">{{
                    $t("members.Assign_Team")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="boss_name"
                sortable="custom"
                property="manager"
                :label="$t('members.Manager')"
                width="120"
              >
                <template slot-scope="scope">
                  <span
                    v-if="
                      Object.keys(incomplete).filter(
                        (k) =>
                          incomplete[k].boss === '' &&
                          (incomplete[k].user_type === 'superleader' ||
                            incomplete[k].user_type === 'superadmin' ||
                            incomplete[k].user_type === 'leadership')
                      ).length == 1 &&
                      !scope.row.boss &&
                      (scope.row.user_type == 'superleader' ||
                        scope.row.user_type == 'superadmin' ||
                        scope.row.user_type == 'leadership')
                    "
                    class="fc-9D9D9D"
                    >*{{ $t("members.Top_Most") }}</span
                  >
                  <span v-else-if="scope.row.boss_shortname"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    scope.row.boss_shortname
                  }}</span>
                  <span v-else class="fc-32C2D5 fs-14">{{
                    $t("members.Assign_Manager")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="coin"
                sortable="custom"
                property="coins"
                :label="$t('members.Coins')"
                width="80"
              >
                <template slot-scope="scope">
                  <div class="center mr-14">
                    {{ $utils("addCommasInNumber", scope.row.coin) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="gem"
                sortable="custom"
                property="gems"
                :label="$t('members.Gems')"
                width="80"
              >
                <template slot-scope="scope">
                  <div class="center mr-14">
                    {{ $utils("addCommasInNumber", scope.row.gem) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="user_type"
                sortable="custom"
                property="permission"
                :label="$t('members.Permission')"
                width="125"
              >
                <template slot-scope="scope">
                  <div>{{ OptuserType[scope.row.user_type] }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="most_recent_activity"
                sortable="custom"
                property="most_recent_activity"
                :label="$t('members.Status')"
                align="right"
                width="90"
              >
                <template slot-scope="scope">
                  <div class="div-active">
                    <div
                      class="btn-status"
                      :class="[`status-${scope.row.status}`]"
                    >
                      {{ scope.row.status }}
                    </div>
                    <div class="active">{{ scope.row.to_now }}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              v-if="loadingMemberTable"
              class="center relative"
              style="margin-top: -60px; z-index: 99"
            >
              <div
                v-for="value in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                :key="'mock_data_on_loading_' + value"
                class="flex-center loading-member-table opa-06"
                :style="`height: 64px; animation-duration: ${value * 1.5 + 1}s`"
              >
                <div class="flex-mid opa-04" style="width: 51px">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                  />
                </div>
                <div class="flex-mid">
                  <div class="image-skeleton image-profile-42 opa-06"></div>
                </div>
                <div class="pl-10" style="width: 174px">
                  <div class="text-skeleton fs-14" style="width: 130px">
                    &nbsp;
                  </div>
                  <div
                    class="text-skeleton fs-14 opa-06 mt-6"
                    style="width: 120px"
                  >
                    &nbsp;
                  </div>
                </div>
                <div class="flex-center" style="width: 160px">
                  <div class="text-skeleton fs-14 ml-10" style="width: 100px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-center" style="width: 120px">
                  <div class="text-skeleton fs-14 ml-10" style="width: 100px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 80px">
                  <div class="text-skeleton fs-14 mr-14" style="width: 20px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 80px">
                  <div class="text-skeleton fs-14 mr-14" style="width: 20px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 125px">
                  <div class="text-skeleton fs-14" style="width: 60px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 90px">
                  <div class="div-active">
                    <div class="btn-status opa-06" style="padding-top: 0">
                      &nbsp;
                    </div>
                    <div
                      class="text-skeleton fs-8 mt-3 mx-auto"
                      style="width: 50px"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-center pagination mt-10">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            :total="results.length"
          ></el-pagination>
          <span class="results-status">
            {{ members.length > 10 ? 10 : members.length }}
            {{ $t("members.results_from") }}
            {{ $utils("addCommasInNumber", results.length) }}
            {{ $t("members.results") }}
          </span>
        </div>
      </div>
      <el-dialog
        :visible.sync="dialogFormVisible"
        top="8vh"
        @close="cancelDialog"
      >
        <el-form :model="validateForm" ref="validateForm">
          <el-col
            :span="13"
            class="thin-scrollbar"
            style="height: 84vh; min-height: 847px; max-height: 1200px"
            v-if="dialogFormVisible"
          >
            <member
              :userDetail="validateForm"
              :orgChartData="modalMemberData['org']"
              :powerData="powerData"
              :modalMemberData="modalMemberData"
            ></member>
          </el-col>
          <el-col :span="11" class="second-column profileform thin-scrollbar">
            <div
              id="modal_profile"
              class="px-40 pb-40"
              style="padding-top: 60px"
            >
              <div
                v-if="
                  directReportsData.total == 0 ||
                  directReportsData.total == undefined
                "
              >
                <div v-if="switchToArchive" class="mt-24 word-break">
                  <div>
                    <span class="fw-700 fs-19 fc-2D2E36">{{
                      $t("members.Are_you_sure_would")
                    }}</span>
                  </div>
                  <div class="pt-20">
                    <span class="fs-16 fc-2D2E36">{{
                      $t("members.Once_archived_the_member")
                    }}</span>
                  </div>
                  <div class="pt-20">
                    <span class="fs-16 fc-2D2E36">{{
                      $t("members.Archived_members_can_be")
                    }}</span>
                  </div>
                  <div class="fs-16 fw-600 mt-24">Archive Schedule</div>
                  <div class="relative mt-8">
                    <el-date-picker
                      v-model="dateAcchivePicker"
                      value-format="yyyy-MM-dd HH:mm"
                      type="datetime"
                      :picker-options="pickerOptions"
                      @change="checkNowPicker"
                      placeholder=""
                      style="width: 100%"
                      :format="`MMMM d hh:mm A`"
                      default-time="23:59:00"
                      :editable="false"
                      popper-class="hide-btn-picker-time"
                    >
                    </el-date-picker>
                    <div
                      v-if="!dateAcchivePicker"
                      class="absolute-mid fs-18 events-none"
                      style="left: 54px"
                    >
                      Now
                    </div>
                  </div>
                  <el-col :span="24" class="flex-center mt-40">
                    <el-button
                      class="btnCancelArchiveModal btn-gray"
                      type="primary"
                      @click="switchToArchive = !switchToArchive"
                      >{{ $t("members.CANCEL") }}</el-button
                    >
                    <el-dropdown @command="archiveMemberType" class="ml-18">
                      <div @click="handleArchiveButtonClick" class="btn btn-archive">
                        ARCHIVE
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="Resigned">Resigned</el-dropdown-item>
                        <el-dropdown-item command="Terminated"
                          >Terminated</el-dropdown-item
                        >
                        <el-dropdown-item command="Other">Other</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-col>
                </div>
                <div v-else class="mt-24">
                  <el-col :span="11">
                    <p class="txtHeaderStyle">{{ $t("members.First_Name") }}</p>
                    <el-input
                      v-model="validateForm.firstname"
                      auto-complete="off"
                      :placeholder="$t('members.First_Name')"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="12">
                    <p class="txtHeaderStyle">{{ $t("members.Last_Name") }}</p>
                    <el-input
                      v-model="validateForm.lastname"
                      auto-complete="off"
                      :placeholder="$t('members.Last_Name')"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <p class="txtHeaderStyle">{{ $t("members.Email") }}</p>
                    <el-input
                      :disabled="this.mode ? true : false"
                      v-model="validateForm.email"
                      auto-complete="off"
                      placeholder="name@company.com"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="24" style="padding-top: 32px">
                    <p class="txtHeaderStyle">{{ $t("members.Manager") }}</p>
                    <el-autocomplete
                      class="inline-input managerfield"
                      v-model="validateForm.dispboss"
                      :fetch-suggestions="querySearchManager"
                      :placeholder="$t('members.Select_a_Manager')"
                      @select="handleSelectManager"
                      @input="handleInputManager"
                      :trigger-on-focus="false"
                      style="width: 100%"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <template slot-scope="{ item }">
                        <div class="flex-center my-7">
                          <div v-if="item.pic">
                            <img
                              v-lazy="item.pic"
                              :key="item.pic"
                              class="image-skeleton image-profile-32 flex-mid mr-12"
                            />
                          </div>
                          <div
                            v-else
                            class="image image-profile-32 flex-mid mr-12"
                          >
                            <div
                              class="text-in-image text-in-image-32 flex-mid"
                            >
                              {{
                                $utils("acronymName", {
                                  firstName: item.firstname,
                                  lastName: item.lastname,
                                })
                              }}
                            </div>
                          </div>
                          <div style="width: 200px; line-height: 16px">
                            <div class="ellipsis">
                              {{ item.firstname + " " + item.lastname }}
                            </div>
                            <div class="ellipsis fs-13 opa-06">
                              {{ item.team_name }}
                            </div>
                          </div>
                          <div
                            style="
                              display: flex;
                              flex: 1;
                              justify-content: flex-end;
                            "
                          >
                            <div class="div-active">
                              <div
                                class="btn-status"
                                :class="[`status-${item.status}`]"
                              >
                                {{ item.status }}
                              </div>
                              <div class="active">{{ item.to_now }}</div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template slot="prepend">
                        <div class="autocomplete-member">
                          <img
                            v-if="validateForm.boss_pic"
                            v-lazy="validateForm.boss_pic"
                            class="image image-skeleton image-profile-52 flex-mid mr-12"
                          />
                          <div
                            v-else
                            class="image image-profile-52 flex-mid mr-12"
                          >
                            <div
                              class="text-in-image text-in-image-52 flex-mid"
                            >
                              {{
                                $utils("acronymName", {
                                  firstName: validateForm.boss_firstname,
                                  lastName: validateForm.boss_lastname,
                                })
                              }}
                            </div>
                          </div>
                          <div class="team-name">
                            {{ validateForm.boss_team_name }}
                          </div>
                        </div>
                      </template>
                    </el-autocomplete>
                    <div class="flex-right">
                      <div
                        v-if="validateForm.dispmanager"
                        style="justify-content: flex-end"
                      >
                        <p
                          class="fs-12 fc-F44336 m-0 pt-6"
                          style="word-break: normal"
                        >
                          {{ validateForm.dispmanager }}
                        </p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <div class="flex-center">
                      <div class="flex-center-1">
                        <p class="txtHeaderStyle">{{ $t("members.Team") }}</p>
                      </div>
                    </div>
                    <el-autocomplete
                      class="inline-input teamfield"
                      :class="
                        [validateForm.team_color
                          ? `border-left-color-${validateForm.team_color}`
                          : 'border-left-color-',
                          blurMode ? 'blurelement': ''
                      ]"
                      v-model="validateForm.dispteam"
                      :fetch-suggestions="querySearchTeam"
                      :placeholder="$t('members.Select_a_Team')"
                      @select="handleSelectTeam"
                      @input="handleInputTeam"
                      style="width: 100%"
                    >
                      <template slot-scope="{ item }">
                        <div class="item"
                        :class="[ blurMode ?  'blurelement': '' ]">{{ item.name }}</div>
                      </template>
                    </el-autocomplete>
                    <div class="flex-right">
                      <div
                        v-if="
                          validateForm.dispteam &&
                          Object.keys(teamByKey).filter(
                            (k) =>
                              teamByKey[k].name.toLowerCase() ===
                              validateForm.dispteam.toLowerCase()
                          ).length == 0
                        "
                        style="justify-content: flex-end"
                      >
                        <p
                          class="fs-12 fc-32C2D5 m-0 pt-6"
                          style="word-break: normal"
                        >
                          "{{ validateForm.dispteam }}"
                          {{ $t("members.will_be_created_as_a") }}
                        </p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" style="padding-top: 32px">
                    <p class="txtHeaderStyle">{{ $t("members.User_role") }}</p>
                    <el-select
                      v-model="validateForm.user_type"
                      class="rolefield"
                      style="width: 100%"
                    >
                      <el-option label="👩🏻  Member" value="user">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >👩🏻 Member</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Limited_Access")
                        }}</span>
                      </el-option>
                      <el-option label="✍🏻  Admin" value="admin">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >✍🏻 Admin</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Email_Notifications")
                        }}</span>
                      </el-option>
                      <el-option label="🛠️  Developer" value="developer">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >🛠️ Developer</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.integrations")
                        }}</span>
                      </el-option>
                      <el-option
                        label="👩🏻‍💻  HR"
                        value="hr"
                        :disabled="
                          user.user_type == 'leadership' ||
                          user.user_type == 'admin'
                        "
                      >
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >👩🏻‍💻 HR</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Insights")
                        }}</span>
                      </el-option>
                      <el-option label="👩🏻‍💼  Leader" value="leadership">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >👩🏻‍💼 Leader</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Insights_Medals")
                        }}</span>
                      </el-option>
                      <el-option
                        label="🦸🏻‍♀️  Super Leader"
                        value="superleader"
                        :disabled="
                          user.user_type == 'leadership' ||
                          user.user_type == 'admin'
                        "
                      >
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >🦸🏻‍♀️ Super Leader</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Insights_Medals")
                        }}</span>
                      </el-option>
                      <el-option
                        label="🙆🏻‍♀️  Super Admin"
                        value="superadmin"
                        :disabled="
                          user.user_type == 'leadership' ||
                          user.user_type == 'admin'
                        "
                      >
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >🙆🏻‍♀️ Super Admin</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Insights_Email")
                        }}</span>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <p class="txtHeaderStyle">
                      {{ $t("members.Language") }}
                    </p>
                    <el-select
                      v-model="validateForm.language"
                      class="langfield"
                      style="width: 100%"
                    >
                      <el-option
                        :label="$t('members.English')"
                        value="en"
                      ></el-option>
                      <el-option
                        :label="$t('members.Thai')"
                        value="th"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <div class="grid-2-50">
                      <div class="mr-8">
                        <p class="txtHeaderStyle">Country</p>
                        <el-select
                          v-model="validateForm.country"
                          class="langfield"
                          style="width: 100%"
                          filterable
                        >
                          <el-option
                            v-for="item in locationOption"
                            :key="item.value"
                            :label="item.value"
                            :value="item.lable"
                          ></el-option>
                          <!-- <el-option
                            label="Thailand"
                            value="thailand"
                          ></el-option> -->
                        </el-select>
                      </div>
                      <div class="ml-8">
                        <p class="txtHeaderStyle">Time Zone</p>
                        <el-select
                          v-model="validateForm.time_zone"
                          class="langfield"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in timeZoneOption"
                            :key="item.lable"
                            :label="item.utcOffsetStr"
                            :value="item.lable"
                            style="height: auto"
                          >
                            <span style="line-height: 14px">
                              <div class="mt-8" style="max-width: 350px">
                                {{ item.utcOffsetStr }}
                              </div>
                              <el-tooltip
                                v-if="item.country.length > 46"
                                placement="top"
                              >
                                <div slot="content" style="max-width: 520px">
                                  {{ item.country }}
                                </div>
                                <div
                                  class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                  style="max-width: 350px"
                                >
                                  {{ item.country }}
                                </div>
                              </el-tooltip>
                              <div
                                v-else
                                class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                style="max-width: 350px"
                              >
                                {{ item.country }}
                              </div>
                            </span>
                          </el-option>
                          <!-- <el-option
                                label="+7:00 GMT"
                                value="480"
                              >
                                <span>+7:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12">Thailand, Indonesia, Vietnam, Laos</span>
                              </el-option>
                              <el-option
                                label="+8:00 GMT"
                                value="540"
                              >
                                <span>+8:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12">Chaina, Brounei, Hong Kong</span>
                              </el-option>
                              <el-option
                                label="+9:00 GMT"
                                value="600"
                              >
                                <span>+9:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12">Japan, South Korea, North Korea</span>
                              </el-option> -->
                        </el-select>
                      </div>
                    </div>
                  </el-col>
                  <el-col v-if="mode" :span="24" class="flex-center mt-32">
                    <el-button class="btnAddMemberModal" @click="saveMember">{{
                      $t("members.SAVE_CHANGES")
                    }}</el-button>
                    <el-button
                      :disabled="this.mode ? false : true"
                      class="btnInviteMemberModal btn-gray"
                      type="primary"
                      @click="inviteMember(validateForm.email)"
                    >
                      <div class="flex-center" style="justify-content: center">
                        <img
                          :src="getImgUrl('ic_mail-18px@2x')"
                          style="width: 18px; height: 18px"
                        />
                        <span style="padding-left: 8px">{{
                          $t("members.SEND_INVITE")
                        }}</span>
                      </div>
                    </el-button>
                  </el-col>
                  <el-col v-else :span="24" class="flex-center mt-32">
                    <div class="flex-center">
                      <el-button
                        class="btnAddMemberModal"
                        @click="saveMember"
                        >{{ $t("members.ADD_MEMBER") }}</el-button
                      >
                      <div class="send-style ml-28">
                        <el-checkbox v-model="checkedAutoSendInvit"
                          ><span></span
                        ></el-checkbox>
                      </div>
                      <div class="fs-13 fw-400 fc-2D2E36">
                        {{ $t("members.Automatically_send_an") }}
                      </div>
                    </div>
                  </el-col>
                  <el-col
                    v-if="this.mode && !scheduledArchive"
                    :span="24"
                    style="padding-top: 13px"
                  >
                    <span
                      class="txtArchivedModal"
                      @click="switchToArchive = !switchToArchive"
                      >{{ $t("members.Archive_employee") }}</span
                    >
                  </el-col>
                  <el-col
                    v-else-if="scheduledArchive"
                    :span="24"
                    style="padding-top: 24px"
                  >
                    <div class="cancel-achive-box mb-22">
                      <div>Scheduled Archive on {{ this.dateArchive }}</div>
                      <div
                        class="link mt-12 cursor-pointer"
                        @click="cancelSchedule"
                      >
                        Cancel Scheduled Archive
                      </div>
                    </div>
                  </el-col>
                </div>
              </div>
              <div v-else>
                <el-tabs v-model="activeProfileTab">
                  <el-tab-pane
                    :label="$t('members.Information')"
                    name="information"
                  >
                    <div v-if="switchToArchive" class="mt-24 word-break">
                      <div>
                        <span class="fw-700 fs-19 fc-2D2E36">{{
                          $t("members.Are_you_sure_would")
                        }}</span>
                      </div>
                      <div class="pt-20">
                        <span class="fs-16 fc-2D2E36"
                          >{{ $t("members.Once_archived_the_member") }}
                        </span>
                      </div>
                      <div class="pt-20">
                        <span class="fs-16 fc-2D2E36">{{
                          $t("members.Archived_members_can_be")
                        }}</span>
                      </div>
                      <div class="fs-16 fw-600 mt-24">Archive Schedule</div>
                      <div class="relative mt-8">
                        <el-date-picker
                          v-model="dateAcchivePicker"
                          value-format="yyyy-MM-dd HH:mm"
                          type="datetime"
                          :picker-options="pickerOptions"
                          @change="checkNowPicker"
                          placeholder=""
                          style="width: 100%"
                          :format="`MMMM d hh:mm A`"
                          default-time="23:59:00"
                          :editable="false"
                          popper-class="hide-btn-picker-time"
                        >
                        </el-date-picker>
                        <div
                          v-if="!dateAcchivePicker"
                          class="absolute-mid fs-18 events-none"
                          style="left: 54px"
                        >
                          Now
                        </div>
                      </div>
                      <el-col :span="24" class="flex-center mt-40">
                        <el-button
                          class="btnCancelArchiveModal btn-gray"
                          type="primary"
                          @click="switchToArchive = !switchToArchive"
                          >{{ $t("members.CANCEL") }}</el-button
                        >
                        <el-dropdown @command="archiveMemberType" class="ml-18">
                          <div @click="handleArchiveButtonClick" class="btn btn-archive">
                            ARCHIVE
                          </div>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="Resigned">Resigned</el-dropdown-item>
                            <el-dropdown-item command="Terminated"
                              >Terminated</el-dropdown-item
                            >
                            <el-dropdown-item command="Other">Other</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-col>
                    </div>
                    <div v-else class="mt-24">
                      <el-col :span="11">
                        <p class="txtHeaderStyle">
                          {{ $t("members.First_Name") }}
                        </p>
                        <el-input
                          v-model="validateForm.firstname"
                          auto-complete="off"
                          :placeholder="$t('members.First_Name')"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="12">
                        <p class="txtHeaderStyle">
                          {{ $t("members.Last_Name") }}
                        </p>
                        <el-input
                          v-model="validateForm.lastname"
                          auto-complete="off"
                          :placeholder="$t('members.Last_Name')"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <p class="txtHeaderStyle">{{ $t("members.Email") }}</p>
                        <el-input
                          :disabled="this.mode ? true : false"
                          v-model="validateForm.email"
                          auto-complete="off"
                          placeholder="name@company.com"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>

                      <el-col :span="24" style="padding-top: 32px">
                        <p class="txtHeaderStyle">
                          {{ $t("members.Manager") }}
                        </p>
                        <el-autocomplete
                          class="inline-input managerfield"
                          v-model="validateForm.dispboss"
                          :fetch-suggestions="querySearchManager"
                          :placeholder="$t('members.Select_a_Manager')"
                          @select="handleSelectManager"
                          @input="handleInputManager"
                          :trigger-on-focus="false"
                          style="width: 100%"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <template slot-scope="{ item }">
                            <div class="flex-center my-7">
                              <div v-if="item.pic">
                                <img
                                  v-lazy="item.pic"
                                  :key="item.pic"
                                  class="image-skeleton image-profile-32 flex-mid mr-12"
                                  :class="[ blurMode ?  'blurelement': '' ]"
                                />
                              </div>
                              <div
                                v-else
                                class="image image-profile-32 flex-mid mr-12"
                                :class="[ blurMode ?  'blurelement': '' ]"
                              >
                                <div
                                  class="text-in-image text-in-image-32 flex-mid"
                                >
                                  {{
                                    $utils("acronymName", {
                                      firstName: item.firstname,
                                      lastName: item.lastname,
                                    })
                                  }}
                                </div>
                              </div>
                              <div style="width: 200px; line-height: 16px"
                              :class="[ blurMode ?  'blurelement': '' ]">
                                <div class="ellipsis">
                                  {{ item.firstname + " " + item.lastname }}
                                </div>
                                <div class="ellipsis fs-13 opa-06">
                                  {{ item.team_name }}
                                </div>
                              </div>
                              <div
                                style="
                                  display: flex;
                                  flex: 1;
                                  justify-content: flex-end;
                                "
                              >
                                <div class="div-active">
                                  <div
                                    class="btn-status"
                                    :class="[`status-${item.status}`]"
                                  >
                                    {{ item.status }}
                                  </div>
                                  <div class="active">{{ item.to_now }}</div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template slot="prepend">
                            <div class="autocomplete-member">
                              <img
                                v-if="validateForm.boss_pic"
                                v-lazy="validateForm.boss_pic"
                                class="image image-skeleton image-profile-52 flex-mid mr-12"
                                :class="[ blurMode ?  'blurelement': '' ]"
                              />
                              <div
                                v-else
                                class="image image-profile-52 flex-mid mr-12"
                                :class="[ blurMode ?  'blurelement': '' ]"
                              >
                                <div
                                  class="text-in-image text-in-image-52 flex-mid"
                                >
                                  {{
                                    $utils("acronymName", {
                                      firstName: validateForm.boss_firstname,
                                      lastName: validateForm.boss_lastname,
                                    })
                                  }}
                                </div>
                              </div>
                              <div class="team-name"
                              :class="[ blurMode ?  'blurelement': '' ]">
                                {{ validateForm.boss_team_name }}
                              </div>
                            </div>
                          </template>
                        </el-autocomplete>
                        <div class="flex-right">
                          <div
                            v-if="validateForm.dispmanager"
                            style="justify-content: flex-end"
                          >
                            <p
                              class="fs-12 fc-F44336 m-0 pt-6"
                              style="word-break: normal"
                            >
                              {{ validateForm.dispmanager }}
                            </p>
                          </div>
                        </div>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <div class="flex-center">
                          <div class="flex-center-1">
                            <p class="txtHeaderStyle">Team</p>
                          </div>
                        </div>
                        <el-autocomplete
                          class="inline-input teamfield"
                          :class="
                          [validateForm.team_color
                          ? `border-left-color-${validateForm.team_color}`
                          : 'border-left-color-',
                          blurMode ? 'blurelement': ''
                      ]"
                          v-model="validateForm.dispteam"
                          :fetch-suggestions="querySearchTeam"
                          :placeholder="$t('members.Select_a_Team')"
                          @select="handleSelectTeam"
                          @input="handleInputTeam"
                          style="width: 100%"
                        >
                          <template slot-scope="{ item }">
                            <div class="item"
                            :class="[ blurMode ?  'blurelement': '' ]">{{ item.name }}</div>
                          </template>
                        </el-autocomplete>
                        <div class="flex-right">
                          <div
                            v-if="
                              validateForm.dispteam &&
                              Object.keys(teamByKey).filter(
                                (k) =>
                                  teamByKey[k].name.toLowerCase() ===
                                  validateForm.dispteam.toLowerCase()
                              ).length == 0
                            "
                            style="justify-content: flex-end"
                          >
                            <p
                              class="fs-12 fc-32C2D5 m-0 pt-6"
                              style="word-break: normal"
                            >
                              "{{ validateForm.dispteam }}"
                              {{ $t("members.will_be_created_as_a") }}
                            </p>
                          </div>
                        </div>
                      </el-col>

                      <el-col :span="24" style="padding-top: 32px">
                        <p class="txtHeaderStyle">
                          {{ $t("members.User_role") }}
                        </p>
                        <el-select
                          v-model="validateForm.user_type"
                          class="rolefield"
                          style="width: 100%"
                        >
                          <el-option label="👩🏻  Member" value="user">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >👩🏻 Member</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Limited_Access")
                            }}</span>
                          </el-option>
                          <el-option label="✍🏻  Admin" value="admin">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >✍🏻 Admin</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Email_Notifications")
                            }}</span>
                          </el-option>
                          <el-option label="🛠️  Developer" value="developer">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >🛠️ Developer</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.integrations")
                            }}</span>
                          </el-option>
                          <el-option
                            label="👩🏻‍💻  HR"
                            value="hr"
                            :disabled="
                              user.user_type == 'leadership' ||
                              user.user_type == 'admin'
                            "
                          >
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >👩🏻‍💻 HR</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Insights")
                            }}</span>
                          </el-option>
                          <el-option label="👩🏻‍💼  Leader" value="leadership">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >👩🏻‍💼 Leader</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Insights_Medals")
                            }}</span>
                          </el-option>
                          <el-option
                            label="🦸🏻‍♀️  Super Leader"
                            value="superleader"
                            :disabled="
                              user.user_type == 'leadership' ||
                              user.user_type == 'admin'
                            "
                          >
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >🦸🏻‍♀️ Super Leader</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Insights_Medals")
                            }}</span>
                          </el-option>
                          <el-option
                            label="🙆🏻‍♀️  Super Admin"
                            value="superadmin"
                            :disabled="
                              user.user_type == 'leadership' ||
                              user.user_type == 'admin'
                            "
                          >
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >🙆🏻‍♀️ Super Admin</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Insights_Email")
                            }}</span>
                          </el-option>
                        </el-select>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <p class="txtHeaderStyle">
                          {{ $t("members.Language") }}
                        </p>
                        <el-select
                          v-model="validateForm.language"
                          class="langfield"
                          style="width: 100%"
                        >
                          <el-option
                            :label="$t('members.English')"
                            value="en"
                          ></el-option>
                          <el-option
                            :label="$t('members.Thai')"
                            value="th"
                          ></el-option>
                        </el-select>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <div class="grid-2-50">
                          <div class="mr-8">
                            <p class="txtHeaderStyle">Country</p>
                            <el-select
                              v-model="validateForm.country"
                              class="langfield"
                              style="width: 100%"
                              filterable
                            >
                              <el-option
                                v-for="item in locationOption"
                                :key="item.value"
                                :label="item.value"
                                :value="item.lable"
                              ></el-option>
                              <!-- <el-option
                                label="Singapore"
                                value="singapore"
                              ></el-option>
                              <el-option
                                label="Thailand"
                                value="thailand"
                              ></el-option> -->
                            </el-select>
                          </div>
                          <div class="ml-8">
                            <p class="txtHeaderStyle">Time Zone</p>
                            <el-select
                              v-model="validateForm.time_zone"
                              class="langfield"
                              style="width: 100%"
                            >
                              <el-option
                                v-for="item in timeZoneOption"
                                :key="item.lable"
                                :label="item.utcOffsetStr"
                                :value="item.lable"
                                style="height: auto"
                              >
                                <span style="line-height: 14px">
                                  <div class="mt-8" style="max-width: 350px">
                                    {{ item.utcOffsetStr }}
                                  </div>
                                  <el-tooltip
                                    v-if="item.country.length > 46"
                                    placement="top"
                                  >
                                    <div
                                      slot="content"
                                      style="max-width: 520px"
                                    >
                                      {{ item.country }}
                                    </div>
                                    <div
                                      class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                      style="max-width: 350px"
                                    >
                                      {{ item.country }}
                                    </div>
                                  </el-tooltip>
                                  <div
                                    v-else
                                    class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                    style="max-width: 350px"
                                  >
                                    {{ item.country }}
                                  </div>
                                </span>
                              </el-option>
                              <!-- <el-option label="+7:00 GMT" value="480">
                                <span>+7:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12"
                                  >Thailand, Indonesia, Vietnam, Laos</span
                                >
                              </el-option>
                              <el-option label="+8:00 GMT" value="540">
                                <span>+8:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12"
                                  >Chaina, Brounei, Hong Kong</span
                                >
                              </el-option>
                              <el-option label="+9:00 GMT" value="600">
                                <span>+9:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12"
                                  >Japan, South Korea, North Korea</span
                                >
                              </el-option> -->
                            </el-select>
                          </div>
                        </div>
                      </el-col>

                      <el-col v-if="mode" :span="24" class="flex-center mt-32">
                        <el-button
                          class="btnAddMemberModal"
                          @click="saveMember"
                          >{{ $t("members.SAVE_CHANGES") }}</el-button
                        >
                        <el-button
                          :disabled="this.mode ? false : true"
                          class="btnInviteMemberModal btn-gray"
                          type="primary"
                          @click="inviteMember(validateForm.email)"
                        >
                          <div
                            class="flex-center"
                            style="justify-content: center"
                          >
                            <img
                              :src="getImgUrl('ic_mail-18px@2x')"
                              style="width: 18px; height: 18px"
                            />
                            <span style="padding-left: 8px">{{
                              $t("members.SEND_INVITE")
                            }}</span>
                          </div>
                        </el-button>
                      </el-col>

                      <el-col v-else :span="24" class="flex-center mt-32">
                        <div class="flex-center">
                          <el-button
                            class="btnAddMemberModal"
                            @click="saveMember"
                            >{{ $t("members.ADD_MEMBER") }}</el-button
                          >
                          <div class="send-style ml-28">
                            <el-checkbox v-model="checkedAutoSendInvit"
                              ><span></span
                            ></el-checkbox>
                          </div>
                          <div class="fs-13 fw-400 fc-2D2E36">
                            {{ $t("members.Automatically_send_an") }}
                          </div>
                        </div>
                      </el-col>

                      <el-col
                        v-if="this.mode && !scheduledArchive"
                        :span="24"
                        style="padding-top: 13px"
                      >
                        <span
                          class="txtArchivedModal"
                          @click="switchToArchive = !switchToArchive"
                          >{{ $t("members.Archive_employee") }}</span
                        >
                      </el-col>
                      <el-col
                        v-else-if="scheduledArchive"
                        :span="24"
                        style="padding-top: 24px"
                      >
                        <div class="cancel-achive-box mb-22">
                          <div>
                            Scheduled Archive on
                            {{ this.dateArchive }}
                          </div>
                          <div
                            class="link mt-12 cursor-pointer"
                            @click="cancelSchedule"
                          >
                            Cancel Scheduled Archive
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane
                    :label="`${$t('members.Direct_Reports')} (${
                      directReportsData.total
                    })`"
                    name="directReports"
                    :disabled="directReportsData.total == 0 ? true : false"
                  >
                    <div class="mt-24">
                      <div class="fs-20 fw-900 fc-2D2E36 mb-16">
                        {{ $t("members.Direct_Reports") }} ({{
                          directReportsData.total
                        }})
                      </div>
                      <div
                        v-for="profile in directReportsData.directReport"
                        :key="profile.id"
                        class="flex-center py-8"
                      >
                        <div class="flex-mid">
                          <img
                            v-if="profile.pic"
                            v-lazy="profile.pic"
                            :alt="profile.firstname + ' ' + profile.lastName"
                            :key="profile.pic"
                            class="image-skeleton image-profile-42 flex-mid mr-12"
                            :class="[ blurMode ?  'blurelement': '' ]"
                          />
                          <div
                            v-else
                            class="image image-profile-42 flex-mid mr-12"
                            :class="[ blurMode ?  'blurelement': '' ]"
                          >
                            <div
                              class="text-in-image text-in-image-42 flex-mid"
                            >
                              {{
                                $utils("acronymName", {
                                  firstName: profile.firstname,
                                  lastName: profile.lastname,
                                })
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="flex-column">
                          <span class="text-name"
                          :class="[ blurMode ?  'blurelement': '' ]"
                            >{{ profile.firstname }}
                            {{ profile.lastname }}</span
                          >
                          <span class="text-email"
                          :class="[ blurMode ?  'blurelement': '' ]">{{ profile.email }}</span>
                        </div>
                        <div
                          class="fs-14 fc-4A4A4A ml-16 ellipsis"
                          style="width: 114px"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          {{ profile.team_name }}
                        </div>
                        <div class="div-active" style="margin-left: auto">
                          <div
                            class="btn-status"
                            :class="[`status-${profile.status}`]"
                          >
                            {{ profile.status }}
                          </div>
                          <div class="active">{{ profile.to_now }}</div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-col>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="assignManagerModalStatus"
        @close="cancelAssignManagerModal"
        top="8vh"
      >
        <div class="modal-2-column modal-edit-team">
          <div class="member-selected rm-scrollbar">
            <div class="fs-20 fc-2D2E36 fw-700 mb-6">
              {{
                checkedData.length > 0
                  ? $utils("addCommasInNumber", checkedData.length)
                  : 0
              }}
              {{ $t("members.members_selected") }}
            </div>
            <div
              v-for="(user, index) in checkedData"
              :key="index + user.email"
              class="flex-center py-8"
            >
              <div class="flex-mid">
                <img
                  v-if="user.pic"
                  v-lazy="user.pic"
                  :alt="user.firstname + ' ' + user.lastname"
                  :key="user.pic"
                  class="image-skeleton image-profile-42 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-42 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-42 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: user.firstname,
                        lastName: user.lastname,
                      })
                    }}
                  </div>
                </div>
              </div>
              <div class="flex-column">
                <span class="text-name"
                :class="[ blurMode ?  'blurelement': '' ]"
                  >{{ user.firstname }} {{ user.lastname }}</span
                >
                <span class="text-email"
                :class="[ blurMode ?  'blurelement': '' ]">{{ user.email }}</span>
              </div>
            </div>
          </div>
          <div class="second-column-modal">
            <div class="fs-24 fc-2D2E36 fw-700 mb-20">
              {{ $t("members.Re_Assign_Manager") }}
            </div>
            <el-input
              class="input-style"
              v-model="manager_assign_disp"
              auto-complete="off"
              :placeholder="$t('members.Search_manager_name')"
              @input="handleInputManagerAssign"
            ></el-input>
            <div class="fs-14 fc-4A4A4A my-24">
              {{ $t("members.Suggestions_based_on_member") }}
            </div>
            <div class="grid-2">
              <div
                v-for="(item, index) in this.managerSuggest"
                :key="index"
                class="card bd-r-3 cursor-pointer"
                @click="assignManagerActiveClick(item, index)"
                :class="{ 'active-card': selectedManagerForAssign === index }"
              >
                <div class="flex-center">
                  <div class="flex-mid">
                    <img
                      v-if="item.pic"
                      v-lazy="item.pic"
                      :alt="item.firstname + item.lastname"
                      :key="item.pic"
                      class="image-skeleton image-profile-40 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-40 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-40 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: item.firstname,
                            lastName: item.lastname,
                          })
                        }}
                      </div>
                    </div>
                    <div class="flex-column" style="width: 55%">
                      <span class="text-name" :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ item.firstname }} {{ item.lastname }}</span
                      >
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]">{{ item.email }}</span>
                    </div>
                    <div class="div-active" style="margin-left: auto">
                      <div
                        class="btn-status"
                        :class="[`status-${item.status}`]"
                      >
                        {{ item.status }}
                      </div>
                      <div class="active">{{ item.to_now }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-reverse mt-30">
              <el-button
                class="btn primary"
                style="margin-left: 12px"
                @click="assignManagerModalSubmit"
                >{{ $t("members.SUBMIT") }}</el-button
              >
              <el-button
                class="btn secondary"
                @click="assignManagerModalStatus = !assignManagerModalStatus"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="assignTeamModalStatus"
        @close="cancelAssignTeamModal"
        top="8vh"
      >
        <div class="modal-2-column modal-edit-team">
          <div class="member-selected rm-scrollbar">
            <div class="fs-20 fc-2D2E36 fw-700 mb-6">
              {{
                checkedData.length > 0
                  ? $utils("addCommasInNumber", checkedData.length)
                  : 0
              }}
              {{ $t("members.members_selected") }}
            </div>
            <div
              v-for="(user, index) in checkedData"
              :key="index + user.email"
              class="flex-center py-8"
            >
              <div class="flex-mid">
                <img
                  v-if="user.pic"
                  v-lazy="user.pic"
                  :alt="user.firstname + user.lastname"
                  :key="user.pic"
                  class="image-skeleton image-profile-42 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-42 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-42 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: user.firstname,
                        lastName: user.lastname,
                      })
                    }}
                  </div>
                </div>
              </div>
              <div class="flex-column"
              :class="[ blurMode ?  'blurelement': '' ]">
                <span class="text-name"
                  >{{ user.firstname }} {{ user.lastname }}</span
                >
                <span class="text-email">{{ user.email }}</span>
              </div>
            </div>
          </div>
          <div class="second-column-modal">
            <div class="fs-24 fc-2D2E36 fw-700 mb-20">
              {{ $t("members.Edit_Team") }}
            </div>
            <el-input
              class="input-style"
              v-model="team_assign_disp"
              auto-complete="off"
              :placeholder="$t('members.Search_team_name')"
              @input="handleInputTeamAssign"
            ></el-input>
            <div class="fs-14 fc-4A4A4A my-24">
              {{ $t("members.Suggestions_based_on_member") }}
            </div>
            <div class="grid-2">
              <div
                v-for="(item, index) in this.teamSuggest"
                :key="index"
                class="card bd-r-3 left-bar left-bar-83 cursor-pointer"
                @click="assignTeamActiveClick(item, index)"
                :class="[
                  { 'active-card': selectedTeamForAssign === index },
                  `bg-${item.color_code}-after`,
                ]"
              >
                <div class="flex-center">
                  <div class="flex-mid">
                    <img
                      v-if="item.boss_pic"
                      v-lazy="item.boss_pic"
                      :alt="item.boss_name"
                      :key="item.boss_pic"
                      class="image-skeleton image-profile-40 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-40 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-40 flex-mid">
                        {{
                          $utils("acronymName", { fullName: item.boss_name })
                        }}
                      </div>
                    </div>
                    <div class="flex-column mr-12">
                      <span class="text-name ellipsis"
                      :class="[ blurMode ?  'blurelement': '' ]" style="width: 238px">{{
                        item.name
                      }}</span>
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ item.count_member_team }}
                        {{ $t("members.members") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-reverse mt-30">
              <el-button
                class="btn primary"
                style="margin-left: 12px"
                @click="assignTeamModalSubmit"
                >{{ $t("members.SUBMIT") }}</el-button
              >
              <el-button
                class="btn secondary"
                @click="assignTeamModalStatus = !assignTeamModalStatus"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="archivedModalStatus"
        top="8vh"
        id="archivedModal"
        @close="cancelAddArchive"
      >
        <div class="p-40">
          <div class="flex-center-1 fs-24 fc-000000 ml-10">
            <span class="fw-900">{{
              resultsArchive.length > 0
                ? $utils("addCommasInNumber", resultsArchive.length)
                : 0
            }}</span>
            <span class="fw-700">&nbsp;Archived Employee</span>
          </div>
          <div
            v-if="
              Object.keys(this.checkedArchive).filter(
                (k) => this.checkedArchive[k] === true
              ).length == 0
            "
            style="margin: 50px -40px 0"
          >
            &nbsp;
          </div>
          <div
            v-else
            class="flex-row-center height-bind ml-10"
            style="background-color: #6c30cc; margin: 15px -40px 0"
          >
            <span class="fs-18 fc-FFFFFF fw-700 ml-40"
              >{{
                $utils(
                  "addCommasInNumber",
                  Object.keys(this.checkedArchive).filter(
                    (k) => this.checkedArchive[k] === true
                  ).length
                )
              }}
              {{ $t("members.members_selected") }}</span
            >
            <div style="margin-left: 24px; display: flex">
              <div
                v-for="(item, index) in this.checkedDataArchive"
                :key="index"
              >
                <div v-if="index < 3">
                  <img
                    v-if="item.pic"
                    v-lazy="item.pic"
                    :alt="item.firstname + item.lastname"
                    class="viewMember image-skeleton image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  />
                  <div
                    v-else
                    class="viewMember image image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  >
                    <div class="text-in-image text-in-image-30 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <span
              v-if="this.checkedDataArchive.length > 3"
              class="fs-14 fc-FFFFFF"
              style="margin-left: -10px"
              >+{{
                this.checkedDataArchive && this.checkedDataArchive.length > 3
                  ? this.checkedDataArchive.length - 3
                  : ""
              }}</span
            >

            <div class="divActionHeader">
              <div
                class="btn btn-navbar bg-hover-barken-54279B opa-05"
                v-if="selcetedArchiveScheduleBoth"
              >
                {{ "CANCEL SCHEDULED ARCHIVE" }}
              </div>
              <div
                @click="unarchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
                v-else-if="!selcetedArchiveSchedule"
              >
                {{ "CANCEL SCHEDULED ARCHIVE" }}
              </div>

              <div
                @click="unarchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
                v-if="selcetedArchiveSchedule"
              >
                {{ $t("members.UNARCHIVE") }}
              </div>
              <div class="btn btn-navbar bg-hover-barken-54279B opa-05" v-else>
                {{ $t("members.UNARCHIVE") }}
              </div>
              <!-- <div
                @click="deleteArchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
                
              >
                {{ $t("members.DELETE") }}
              </div> -->
              <div
                v-if="selcetedArchiveSchedule"
                @click="deleteArchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.DELETE") }}
              </div>
              <div v-else class="btn btn-navbar bg-hover-barken-54279B opa-05">
                {{ $t("members.DELETE") }}
              </div>
            </div>
          </div>
          <div>
            <div class="flex-row-between mt-14 ml-12">
              <el-input
                class="input-style"
                style="height: 40px"
                autosize
                :placeholder="$t('members.Search')"
                v-model="inputSearchArchive"
                clearable
              ></el-input>
              <button
                @click="deleteArchiveAllClick"
                class="button btn-red cursor-pointer"
              >
                {{ $t("members.delete_all") }}
              </button>
            </div>
          </div>
          <div class="mt-10">
            <el-table
              ref="multipleTable"
              :data="membersArchive"
              style="width: 100%"
              :empty-text="
                loadingArchiveTable
                  ? ' '
                  : !membersArchive && inputSearchArchive === ''
                  ? 'No archived employees'
                  : 'No results found...'
              "
              @sort-change="sortArchive"
            >
              <el-table-column
                :render-header="renderOptionSelectArchive"
                column-key="memberCheckbox"
                width="51"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                    v-model="checkedArchive['key_' + scope.row.key]"
                    :key="scope.row.key"
                    @change="membersCheckedArchive(scope.row.key)"
                  />
                </template>
              </el-table-column>

              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: scope.row.firstname,
                            lastName: scope.row.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="name"
                sortable="custom"
                :label="$t('members.Member')"
                width="170"
              >
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                      >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                    >
                    <span class="text-email"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="team_name"
                sortable="custom"
                property="team"
                :label="$t('members.Team')"
                width="160"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.team_name" 
                  :class="[ blurMode ?  'blurelement': '' ]"
                  style="color: #4a4a4a">{{
                    scope.row.team_name
                  }}</span>
                  <span v-else class="fc-32C2D5 fs-14" 
                  :class="[ blurMode ?  'blurelement': '' ]"
                  style="color: #4a4a4a">{{
                    $t("members.Assign_Team")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="coin"
                sortable="custom"
                property="coins"
                :label="$t('members.Coins')"
                width="80"
              >
                <template slot-scope="scope">
                  <div class="center mr-14" style="color: #4a4a4a">
                    {{ scope.row.coin }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="gem"
                sortable="custom"
                property="gems"
                label="Gems"
                width="80"
              >
                <template slot-scope="scope">
                  <div class="center mr-14" style="color: #4a4a4a">
                    {{ scope.row.gem }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="user_type"
                sortable="custom"
                property="permission"
                label="Archived Type"
                width="135"
              >
                <template slot-scope="scope">
                  <!-- <div>{{ OptuserType[scope.row.user_type] }}</div> -->
                  <div class="flex-mid">
                    <el-dropdown @command="selectArchivedType">
                      <span class="fs-14" style="color: #4a4a4a">
                        <span
                        :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ scope.row.archive_type }}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          :command="{ type: 'Resigned', user: scope.row }"
                          :disabled="'Resigned' == scope.row.archive_type"
                          >Resigned</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{ type: 'Terminated', user: scope.row }"
                          :disabled="'Terminated' == scope.row.archive_type"
                          >Terminated</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{ type: 'Other', user: scope.row }"
                          :disabled="'Other' == scope.row.archive_type"
                          >Other</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="archiveddate"
                sortable="custom"
                property="archiveddate"
                label="Archived Date"
                align="center"
                width="140"
              >
                <template slot-scope="scope">
                  <div style="color: #4a4a4a">{{ scope.row.archiveddate }}</div>
                </template>
              </el-table-column>

              <el-table-column
                prop="status"
                property="status"
                label
                align="right"
                width="90"
              >
                <template slot-scope="scope">
                  <div
                    @click="unarchiveMemberClick(scope.row)"
                    class="center text-link"
                    v-if="scope.row.archiveSchedule"
                  >
                    Cancel Scheduled Archive
                  </div>
                  <div
                    @click="unarchiveMemberClick(scope.row)"
                    class="center text-link"
                    v-else
                  >
                    Unarchive
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                property="status"
                label
                align="right"
                width="70"
              >
                <template slot-scope="scope">
                  <div
                    @click="deleteArchiveMemberClick(scope.row.key)"
                    class="center text-link"
                    v-if="!scope.row.archiveSchedule"
                  >
                    Delete
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              class="center mt-10 mb-40 pt-10 pb-40"
              v-if="loadingArchiveTable"
            >
              <loading-even></loading-even>
            </div>
          </div>
          <div class="flex-center pagination mt-10">
            <el-pagination
              @current-change="handleArchiveCurrentChange"
              :current-page="pagearchive"
              :page-size="10"
              :pager-count="5"
              layout="prev, pager, next"
              :total="resultsArchive.length"
            ></el-pagination>
            <span class="results-status">
              {{ resultsArchive.length > 10 ? 10 : resultsArchive.length }}
              {{ $t("members.results_from") }}
              {{ $utils("addCommasInNumber", resultsArchive.length) }}
              {{ $t("members.results") }}
            </span>
          </div>
        </div>
      </el-dialog>

      <!-- Review Updates Dialog: xxx -->
      <el-dialog
        :visible.sync="reviewUpdatesModalStatus"
        top="8vh"
        id="reviewUpdatesModal"
        @close="cancelReviewUpdates"
      >
        <div class="p-40">
          <div class="flex-center-1 fs-24 fc-000000 ml-10">
            <span class="fw-900">{{
              reviewUpdatesAll.length > 0
                ? $utils("addCommasInNumber", reviewUpdatesAll.length)
                : 0
            }}</span>
            <span class="fw-700">&nbsp;{{ $t("members.REVIEW_UPDATES") }}</span>
          </div>
          <div
            v-if="
              Object.keys(this.checkedReviewUpdates).filter(
                (k) => this.checkedReviewUpdates[k] === true
              ).length == 0
            "
            style="margin: 15px -15px 0px -40px"
          >
            &nbsp;
          </div>
          <div
            v-else
            class="flex-row-center height-bind ml-10"
            style="background-color: #6c30cc; margin: 15px -15px 0px -40px"
          >
            <span class="fs-18 fc-FFFFFF fw-700 ml-40"
              >{{
                $utils(
                  "addCommasInNumber",
                  Object.keys(this.checkedReviewUpdates).filter(
                    (k) => this.checkedReviewUpdates[k] === true
                  ).length
                )
              }}
              {{ $t("members.members_selected") }}</span
            >
            <div style="margin-left: 24px; display: flex">
              <div
                v-for="(item, index) in this.checkedDataReviewUpdates"
                :key="index"
              >
                <div v-if="index < 3">
                  <img
                    v-if="item.pic"
                    v-lazy="item.pic"
                    :alt="item.firstname + item.lastname"
                    class="viewMember image-skeleton image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  />
                  <div
                    v-else
                    class="viewMember image image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  >
                    <div class="text-in-image text-in-image-30 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <span
              v-if="this.checkedDataReviewUpdates.length > 3"
              class="fs-14 fc-FFFFFF"
              style="margin-left: -10px"
              >+{{
                this.checkedDataReviewUpdates && this.checkedDataReviewUpdates.length > 3
                  ? this.checkedDataReviewUpdates.length - 3
                  : ""
              }}</span
            >

            <!-- Bulk Actions -->
            <div class="divActionHeader">
              <div
                v-if="bulkReAssignManagerStatus"
                class="btn btn-navbar bg-hover-barken-54279B"
                @click="bulkCommandReviewUpdates('reAssignManager')"
              >
                {{ $t("members.RE_ASSIGN_MANAGER") }}
              </div>
              <div
                v-else
                class="btn btn-navbar bg-hover-barken-54279B opa-05"
              >
                {{ $t("members.RE_ASSIGN_MANAGER") }}
              </div>

              <div
                v-if="bulkAddUserStatus"
                class="btn btn-navbar bg-hover-barken-54279B"
                @click="bulkCommandReviewUpdates('addUser')"
              >
                {{ $t("members.ADD") }}
              </div>
              <div
                class="btn btn-navbar bg-hover-barken-54279B opa-05"
                v-else
              >
                {{ $t("members.ADD") }}
              </div>

              <div
                v-if="bulkArchiveStatus"
                class="btn btn-navbar bg-hover-barken-54279B"
                @click="bulkCommandReviewUpdates('archive')"
              >
                {{ $t("members.ARCHIVE") }}
              </div>
              <div class="btn btn-navbar bg-hover-barken-54279B opa-05" v-else>
                {{ $t("members.ARCHIVE") }}
              </div>

              <div
                v-if="bulkIgnoreStatus"
                @click="bulkCommandReviewUpdates('ignore')"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.IGNORE") }}
              </div>
              <div class="btn btn-navbar bg-hover-barken-54279B opa-05" v-else>
                {{ $t("members.IGNORE") }}
              </div>
            </div>
          </div>

          <!-- Search bar -->
          <div v-if="false">
            <div class="flex-row-between mt-14 ml-12">
              <el-input
                class="input-style"
                style="height: 40px"
                autosize
                :placeholder="$t('members.Search')"
                v-model="inputSearchArchive"
                clearable
              ></el-input>
              <button
                @click="deleteArchiveAllClick"
                class="button btn-red cursor-pointer"
              >
                {{ $t("members.delete_all") }}
              </button>
            </div>
          </div>

          <!-- Table -->
          <div class="mt-10">
            <el-table
              ref="multipleTable"
              id="reviewUpdatesTable"
              :data="reviewUpdates"
              style="width: 100%"
              :empty-text="
                reviewUpdatesLoading
                  ? ' '
                  : !reviewUpdates && inputSearchArchive === ''
                  ? 'No archived employees'
                  : 'No results found...'
              "
              @sort-change="sortReviewUpdates"
            >
              <!-- Checkbox -->
              <el-table-column
                :render-header="renderOptionSelectReviewUpdates"
                column-key="memberCheckbox"
                width="51"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                    v-model="checkedReviewUpdates['key_' + scope.row.key]"
                    :key="scope.row.key"
                    @change="membersCheckedReviewUpdates(scope.row.key)"
                  />
                </template>
              </el-table-column>

              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: scope.row.firstname,
                            lastName: scope.row.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="name"
                sortable="custom"
                :label="$t('members.Member')"
                width="170"
              >
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                      >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                    >
                    <span class="text-email"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                    <!-- {{ scope.row.key }} <br />
                    {{ scope.row.source }}: {{ scope.row.type }} -->
                  </div>
                </template>
              </el-table-column>

              <!-- Team -->
              <el-table-column
                prop="team_name"
                property="team"
                :label="$t('members.Team')"
                width="150"
              >
                <template slot-scope="scope">
                  <el-select
                    v-if="canEdit(scope.row, 'team')"
                    v-model="reviewUpdates[scope.$index].team"
                    class=""
                    style="width: 100%"
                    filterable
                    :class="[ blurMode ?  'blurelement': '' ]"
                  >
                    <el-option label="Assign Team" value=""></el-option>
                    <el-option
                        v-for="item in teamOptions"
                        :key="`team_${item.key}`"
                        :label="item.value"
                        :value="item.key"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      ></el-option>
                  </el-select>
                  <div v-else
                  :class="[ blurMode ?  'blurelement': '' ]">
                    {{ scope.row.team_name }}
                  </div>
                </template>
              </el-table-column>

              <!-- Manager -->
              <el-table-column
                prop="manager_name"
                property="manager"
                :label="$t('members.Manager')"
                width="165"
              >
                <template slot-scope="scope">
                  <el-select
                    v-if="canEdit(scope.row, 'manager')"
                    v-model="reviewUpdates[scope.$index].manager"
                    class="langfield"
                    style="width: 100%"
                    filterable
                    :class="[ blurMode ?  'blurelement': '' ]"
                    :ref="`managerSelects[${[reviewUpdates[scope.$index].key]}]`"
                  >
                    <el-option label="Assign Manager" value=""></el-option>
                    <el-option
                          v-for="item in managerOptions"
                          :key="`manager_${item.key}`"
                          :label="item.value"
                          :value="item.key"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-option>
                  </el-select>
                  <div v-else
                  :class="[ blurMode ?  'blurelement': '' ]">
                    {{ scope.row.manager_name }}
                  </div>
                </template>
              </el-table-column>

              <!-- Languge -->
              <el-table-column
                prop="language"
                property="language"
                :label="$t('members.Language')"
                width="120"
              >
                <template slot-scope="scope">
                  <el-select
                    v-if="canEdit(scope.row, 'language')"
                    v-model="reviewUpdates[scope.$index].language"
                    class="langfield"
                    style="width: 100%"
                  >
                    <el-option
                      :label="$t('members.English')"
                      value="en"
                    ></el-option>
                    <el-option
                      :label="$t('members.Thai')"
                      value="th"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <!-- Country -->
              <el-table-column
                prop="country"
                property="country"
                :label="$t('members.Country')"
                width="120"
              >
                <template slot-scope="scope">
                  <el-select
                    v-if="canEdit(scope.row, 'country')"
                    v-model="reviewUpdates[scope.$index].country"
                    class="langfield"
                    style="width: 100%"
                    filterable
                  >
                    <el-option
                      v-for="item in locationOption"
                      :key="item.value"
                      :label="item.value"
                      :value="item.lable"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <!-- Archived Type -->
              <el-table-column
                prop="archived_type"
                property="archived_type"
                :label="$t('members.Archived_Type')"
                width="110"
              >
                <template slot-scope="scope">
                  <div class="flex-mid">
                    <el-dropdown @command="handleArchivedType"
                      v-if="canEdit(scope.row, 'archived_type')">
                      <span class="fs-14" style="color: #4a4a4a">
                        <span>{{ scope.row.archived_type }}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          :command="{ type: 'Resigned', item: scope.row }"
                          :disabled="'Resigned' == scope.row.archived_type"
                          >Resigned</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{ type: 'Terminated', item: scope.row }"
                          :disabled="'Terminated' == scope.row.archived_type"
                          >Terminated</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{ type: 'Other', item: scope.row }"
                          :disabled="'Other' == scope.row.archived_type"
                          >Other</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>

              <!-- Actions -->
              <el-table-column
                v-if="true"
                prop="action"
                property="action"
                label
                align="right"
                width="117"
              >
                <template slot-scope="scope">
                  <!-- HRIS: create|edit -->
                  <el-button
                    v-if="scope.row.source == 'hris' && (scope.row.type === 'create')"
                    class="btnAddMember"
                    style="width: 83px"
                    size="small"
                    icon="el-icon-plus"
                    @click="runCommandReviewUpdates(scope.row.key)"
                    >{{ $t("members.ADD") }}</el-button
                  >
                  <el-button
                    v-if="scope.row.source == 'hris' && (scope.row.type === 'update')"
                    class="btnAddMember"
                    style="width: 83px"
                    size="small"
                    @click="runCommandReviewUpdates(scope.row.key)"
                    >{{ $t("members.EDIT") }}</el-button
                  >
                  <!-- HRIS: delete -->
                  <el-button
                    v-if="scope.row.source == 'hris' && scope.row.type === 'delete'"
                    class="btnDeleteMember"
                    size="small"
                    @click="runCommandReviewUpdates(scope.row.key)"
                  >
                    {{ $t("members.ARCHIVE") }}
                  </el-button>
                  <!-- APP: direct_manager -->
                  <el-button
                    v-if="scope.row.source == 'app' && scope.row.type == 'add_member'"
                    class="btnAddMember"
                    style="width: 83px"
                    size="small"
                    icon="el-icon-plus"
                    @click="runCommandReviewUpdates(scope.row.key)"
                  >{{ $t("members.ADD") }}</el-button
                  >
                  <el-button
                    v-if="scope.row.source == 'app' && scope.row.type != 'add_member'"
                    class="btnDeleteMember"
                    size="small"
                    @click="runCommandReviewUpdates(scope.row.key)"
                  >
                    {{ $t(getAppButtonLabelKey(scope.row.type)) }}
                  </el-button>
                  <div class="fs-11 fw-400 italic requested_by"
                  :class="[ blurMode ?  'blurelement': '' ]"
                   v-if="scope.row.requested_by">{{ "Requested by " + scope.row.requested_by }}</div>
                </template>
              </el-table-column>

            </el-table>
            <div
              class="center mt-10 mb-40 pt-10 pb-40"
              v-if="reviewUpdatesLoading"
            >
              <loading-even></loading-even>
            </div>
          </div>
          <div class="flex-center pagination mt-10">
            <el-pagination
              @current-change="handleReviewUpdatesCurrentChange"
              :current-page="pageReviewUpdates"
              :page-size="10"
              :pager-count="5"
              layout="prev, pager, next"
              :total="reviewUpdatesTotal"
            ></el-pagination>
            <span class="results-status">
              {{ reviewUpdatesTotal > 10 ? 10 : reviewUpdatesTotal }}
              {{ $t("members.results_from") }}
              {{ $utils("addCommasInNumber", reviewUpdatesTotal) }}
              {{ $t("members.results") }}
            </span>
          </div>
        </div>
      </el-dialog>


    </div>
    <div id="managerWarmingModal">
      <el-dialog
        title=""
        :visible.sync="completeManagerWarmingModal"
        width="540px"
      >
        <div class="center mt-10">
          <div class="fs-20 fw-700 fc-2D2E36">
            {{ $t("members.Complete_manager_assignment") }}
          </div>
          <div class="fs-16 fc2D2E36 mt-24 px-40 word-break">
            <span class="fw-700">
              {{
                completeManagerWarmingData.firstname +
                " " +
                completeManagerWarmingData.lastname
              }}
            </span>
            {{ $t("members.is_missing_a_direct") }}
          </div>
        </div>
        <div style="margin-top: 60px" class="flex-mid">
          <el-button
            class="btn btn-add"
            style="width: 360px; height: 50px"
            @click="showReAssignManagerModal('complete')"
            >{{ $t("members.SELECT_DIRECT_MANAGER") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="reAssignManagerWarmingModal"
        width="540px"
      >
        <div class="center mt-10">
          <div class="fs-20 fw-700 fc-2D2E36">
            <div>Re-assign a manager to replace</div>
            <div>the archived manager</div>
          </div>
          <div class="fs-16 fc2D2E36 mt-24 px-40 word-break">
            <span class="fw-700">
              {{
                reAssignManagerWarmingData.firstname +
                " " +
                reAssignManagerWarmingData.lastname
              }}
            </span>
            {{ $t("members.has_been_archived_leaving") }}
            {{ reAssignManagerWarmingData.member }}
            {{ $t("members.members_without_a_direct") }}
          </div>
        </div>
        <div style="margin-top: 60px" class="flex-mid">
          <el-button
            class="btn btn-add"
            style="width: 360px; height: 50px"
            @click="showReAssignManagerModal('reassign')"
            >{{ $t("members.RE_ASSIGN_MANAGER") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div id="reAssignManagerModal">
      <el-dialog :visible.sync="reAssignManagerModal" top="8vh">
        <el-col :span="8" class="first-column-modal rm-scrollbar">
          <div class="fs-20 fc-2D2E36 fw-700 mb-6">
            {{
              subCheckedData.length > 0
                ? $utils("addCommasInNumber", subCheckedData.length)
                : 0
            }}
            {{ $t("members.members_selected") }}
          </div>
          <div
            v-for="(user, index) in subCheckedData"
            :key="index + user.email"
            @click="ManagerSelectedClick(user, index)"
            class="flex-center py-8 cursor-pointer"
          >
            <div class="flex-mid">
              <img
                v-if="user.pic"
                v-lazy="user.pic"
                :alt="user.firstname + ' ' + user.lastname"
                :key="user.pic"
                class="image-skeleton image-profile-42 flex-mid mr-12"
              />
              <div v-else class="image image-profile-42 flex-mid mr-12">
                <div class="text-in-image text-in-image-42 flex-mid">
                  {{
                    $utils("acronymName", {
                      firstName: user.firstname,
                      lastName: user.lastname,
                    })
                  }}
                </div>
              </div>
            </div>
            <div class="flex-column">
              <span class="text-name"
                >{{ user.firstname }} {{ user.lastname }}</span
              >
              <span class="text-email">{{ user.email }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="16" class="second-column-modal">
          <div class="fs-24 fc-2D2E36 fw-700 mb-20">
            {{ $t("members.Re_Assign_Manager") }}
          </div>
          <el-input
            class="input-style"
            v-model="manager_assign_disp"
            auto-complete="off"
            :placeholder="$t('members.Search_manager_name')"
            @input="handleInputManagerReAssign"
          ></el-input>
          <div class="fs-14 fc-4A4A4A my-24">
            {{ $t("members.Suggestions_based_on_member") }}
          </div>
          <div class="grid-2">
            <div
              v-for="(item, index) in this.managerSuggest"
              :key="index"
              class="card bd-r-3 cursor-pointer"
              @click="ReAssignManagerActiveClick(item, index)"
              :class="{ 'active-card': selectedManagerForReAssign === index }"
            >
              <div class="flex-center">
                <div class="flex-mid">
                  <img
                    v-if="item.pic"
                    v-lazy="item.pic"
                    :alt="item.firstname + item.lastname"
                    :key="item.pic"
                    class="image-skeleton image-profile-40 flex-mid mr-12"
                  />
                  <div v-else class="image image-profile-40 flex-mid mr-12">
                    <div class="text-in-image text-in-image-40 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div class="flex-column" style="width: 150px">
                  <span class="text-name"
                    >{{ item.firstname }} {{ item.lastname }}</span
                  >
                  <span class="text-email">{{ item.email }}</span>
                </div>
                <div class="div-active" style="margin-left: auto">
                  <div class="btn-status" :class="[`status-${item.status}`]">
                    {{ item.status }}
                  </div>
                  <div class="active">{{ item.to_now }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-reverse mt-30">
            <el-button
              class="btn primary"
              style="margin-left: 12px"
              @click="reAssignManagerModalSubmit"
              >{{ $t("members.SUBMIT") }}</el-button
            >
            <el-button
              class="btn secondary"
              @click="reAssignManagerModal = !reAssignManagerModal"
              >{{ $t("members.CANCEL") }}</el-button
            >
          </div>
        </el-col>
      </el-dialog>
    </div>
    <div id="archiveMember">
      <el-dialog
        title=""
        width="560px"
        :visible.sync="archiveMutipleMemberModal"
        top="8vh"
      >
        <div class="center word-break" style="padding: 10px 50px">
          <div class="fs-20 fw-700 fc-2D2E36">
            Are you sure you want to archive the
            {{ this.checkedData.length }}
            selected members?
          </div>
          <div class="fs-16 fc-2D2E36 mt-24">
            Once archived, the members will be logged out of Happily and will
            not be able to log in again.
          </div>
          <div class="fs-16 fc-2D2E36 mt-16">
            Archived members can be restored at a later time.
          </div>
          <div class="pl-20 pr-20">
            <div class="relative mt-24 mb-24">
              <el-date-picker
                v-model="dateAcchivePicker"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                :picker-options="pickerOptions"
                @change="checkNowPicker"
                placeholder=""
                style="width: 100%"
                :format="`MMMM d hh:mm A`"
                default-time="23:59:00"
                :editable="false"
                popper-class="hide-btn-picker-time"
              >
              </el-date-picker>
              <div
                v-if="!dateAcchivePicker"
                class="absolute-mid fs-18 events-none"
                style="left: 56px"
              >
                Now
              </div>
            </div>
            <el-dropdown @command="archiveMemberByGroupType" @click="confirmArchiveMember" class="ml-18">
              <div @click="handleArchiveButtonClick" class="btn btn-archive">
                ARCHIVE
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Resigned">Resigned</el-dropdown-item>
                <el-dropdown-item command="Terminated"
                  >Terminated</el-dropdown-item
                >
                <el-dropdown-item command="Other">Other</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import { dragscroll } from "vue-dragscroll";
import format from "date-fns/format";
export default {
  directives: {
    dragscroll,
  },
  name: "members",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
    Member: require("@/components/content/user-profile-details").default,
  },
  data() {
    return {
      id: "",
      mode: "",
      checked: [],
      checkedArchive: [],
      checkedData: [],
      checkedDataArchive: [],
      OptuserType: {
        user: "👩🏻 Member",
        hr: "👩🏻‍💻 HR",
        admin: "✍🏻 Admin",
        developer: "🛠️ Developer",
        leadership: "👩🏻‍💼 Leadership",
        superleader: "🦸🏻‍♀️ Super Leader",
        superadmin: "🙆🏻‍♀️ Super Admin",
        ghost: "👻 Ghost",
      },
      multipleSelection: [],
      type: "all",
      showSnackbar: false,
      isInfinity: false,
      dialogFormVisible: false,
      activeProfileTab: "information",
      directReportsData: {},
      // directReportsData: {
      //   total: 2,
      //   directReport: [
      //     {
      //       id: "idbrabra1",
      //       firstname: "First",
      //       lastname: "lastName",
      //       email: "name@workemail.com",
      //       teamName: "Team Name",
      //       status: "active",
      //       to_now: "2 hours ago"
      //     },
      //     {
      //       id: "idbrabra2",
      //       firstname: "Second",
      //       lastname: "lastName",
      //       email: "name2@workemail.com",
      //       teamName: "Team Name",
      //       status: "active",
      //       to_now: "1 hours ago"
      //     }
      //   ]
      // },
      validateForm: {
        pic: "",
        firstname: "",
        lastname: "",
        email: "",
        dispteam: "",
        team_color: "",
        dispboss: "",
        team: "",
        boss: "",
        tmp_boss: "",
        boss_pic: "",
        boss_firstname: "",
        boss_lastname: "",
        language: "th",
        country: "TH",
        time_zone: "+07:00",
        user_type: "user",
        // invite: true,
        status: "new",
        to_now: "",
        streak_count: 0,
        super_feedback_count: 0,
        medal: [],
        coin: 0,
        gem: 0,
        house: "",
        joined: "",
        joined_tooltips: [],
        dispmanager: "",
        introduce: "",
        culture_add_percentile: "",
      },
      activeName: "powers",
      assignManagerModalStatus: false,
      selectedManagerForAssign: null,
      managerSuggest: [],
      managerSuggest_temp: [],
      assignManager: "",
      manager_assign_disp: "",
      assignTeamModalStatus: false,
      selectedTeamForAssign: null,
      teamSuggest: [],
      teamSuggest_temp: [],
      assignTeam: "",
      team_assign_disp: "",
      switchToArchive: false,
      archivedModalStatus: false,
      checkAll: [],
      checkAll_temp: false,
      checkAllArchive: [],
      checkAllArchive_temp: false,
      checkedAutoSendInvit: true,
      reAssignManagerWarmingModal: false,
      reAssignManagerWarmingData: {
        firstname: "",
        lastname: "",
        member: 0,
        email: "",
      },
      completeManagerWarmingModal: false,
      completeManagerWarmingData: {
        firstname: "",
        lastname: "",
        email: "",
      },
      reAssignManagerModal: false,
      selectedManagerForReAssign: null,
      manager_assign_disp: "",
      subCheckedData: [],
      managerSuggest: [],
      managerSuggest_temp: [],
      reAssignManager: "",
      archiveMutipleMemberModal: false,
      dateAcchivePicker: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        selectableRange: "",
      },
      dateArchive: "",
      // powerData: [
      //   {
      //     label: "Empathy",
      //     value: 4361,
      //     maxValue: 4590,
      //     icon: "ic_empathy",
      //   },
      // ],
      scheduledArchive: false,
      selcetedArchiveSchedule: false,
      selcetedArchiveScheduleBoth: false,

      // Review Updates: xxx
      reviewUpdatesModalStatus: false,
      checkedReviewUpdates: [],
      checkedDataReviewUpdates: [],
      checkAllReviewUpdates: [],
      checkAllReviewUpdates_temp: false,
      bulkReAssignManagerStatus: false,
      bulkAddUserStatus: false,
      bulkArchiveStatus: false,
      bulkIgnoreStatus: true,
    };
  },
  created() {
    this.$store.dispatch("newmember/getOrganization");
    this.$store.dispatch("newmember/getMember", this.user);
    this.$store.dispatch("newmember/getTeamAll", this.user);
    this.$store.dispatch("newmember/getTimezone", this.user);
    // this.$store.dispatch("newmember/checkEndingloopTeamParent", this.user);
    this.$store.commit("authen/setActiveIndex", "2");
    // this.riskData = mockData;
    this.datePickerUpdateTime();

    // @todo realtime update review updates total (balloon number)
    this.getReviewUpdatesTotal();
    this.$root.$on('archivedModalClick', () => this.archivedModalClick());
    this.$root.$on('clickReviewUpdates', () => this.clickReviewUpdates());
    this.$root.$on('addMember', () => this.addMember());
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("newmember/searchMembers", this.inputSearch);
    },
    inputSearchArchive() {
      this.$store.dispatch(
        "newmember/searchMembersArchive",
        this.inputSearchArchive
      );
    },
    allUser() {
      // this.$store.dispatch("newmember/getMember", this.user);
      this.$store.dispatch("newmember/getTeamAll", this.user);
    },
    teamParentByKey() {
      if (
        Object.keys(this.teamParentByKey).filter((k) => this.teamParentByKey[k])
          .length > 0
      ) {
        let memberData = this.checkedData;
        this.teamSuggest = [];
        this.teamSuggest_temp = [];
        this.assignTeam = "";
        this.selectedTeamForAssign = null;
        for (const i in memberData) {
          if (this.teamSuggest.length < 8) {
            if (memberData[i].boss) {
              /*direc manager*/
              let bossKeyID = memberData[i].boss.replace(/\./g, "||");
              if (
                this.membersByKey[bossKeyID] &&
                this.membersByKey[bossKeyID].team
              ) {
                let teamIdBoss = this.membersByKey[bossKeyID].team;
                let chk_teamExist = _.filter(this.teamSuggest, {
                  key: teamIdBoss,
                });
                if (chk_teamExist.length == 0) {
                  let teamData = this.teamByKey[teamIdBoss];
                  teamData.key = teamIdBoss;
                  teamData.color_code = teamData.color
                    ? teamData.color.replace(/#/g, "")
                    : "747474";
                  teamData.boss_pic = this.teamParentByKey[teamIdBoss]
                    ? this.teamParentByKey[teamIdBoss].pic
                    : "";
                  teamData.boss_name = this.teamParentByKey[teamIdBoss]
                    ? this.teamParentByKey[teamIdBoss].boss_firstname +
                      " " +
                      this.teamParentByKey[teamIdBoss].boss_lastname
                    : "";
                  teamData.count_member_team = this.teamParentByKey[teamIdBoss]
                    ? this.teamParentByKey[teamIdBoss].sup.length
                    : 0;
                  this.teamSuggest.push(teamData);
                  this.teamSuggest_temp.push(teamData);
                }

                /*share direct manager*/
                if (this.teamByKey[teamIdBoss]) {
                  let shareTeam = _.filter(this.team, { parent: teamIdBoss });
                  if (shareTeam.length > 0) {
                    for (const j in shareTeam) {
                      if (this.teamSuggest.length < 8) {
                        if (this.teamByKey[shareTeam[j].key]) {
                          let chk_teamExist = _.filter(this.teamSuggest, {
                            key: shareTeam[j].key,
                          });
                          if (chk_teamExist.length == 0) {
                            let teamData = this.teamByKey[shareTeam[j].key];
                            teamData.key = shareTeam[j].key;
                            teamData.color_code = teamData.color
                              ? teamData.color.replace(/#/g, "")
                              : "747474";
                            teamData.boss_pic = this.teamParentByKey[
                              shareTeam[j].key
                            ]
                              ? this.teamParentByKey[shareTeam[j].key].pic
                              : "";
                            teamData.boss_name = this.teamParentByKey[
                              shareTeam[j].key
                            ]
                              ? this.teamParentByKey[shareTeam[j].key]
                                  .boss_firstname +
                                " " +
                                this.teamParentByKey[shareTeam[j].key]
                                  .boss_lastname
                              : "";
                            teamData.count_member_team = this.teamParentByKey[
                              shareTeam[j].key
                            ]
                              ? this.teamParentByKey[shareTeam[j].key].sup
                                  .length
                              : 0;
                            this.teamSuggest.push(teamData);
                            this.teamSuggest_temp.push(teamData);
                          }
                        }
                      } else {
                        return;
                      }
                    }
                  }
                }
              }
              /*selected member*/
              let selected_team_parent = _.filter(this.team, {
                parent: memberData[i].team,
              });
              if (selected_team_parent.length > 0) {
                for (const k in selected_team_parent) {
                  if (this.teamSuggest.length < 8) {
                    if (this.teamByKey[selected_team_parent[k].key]) {
                      let chk_teamExist = _.filter(this.teamSuggest, {
                        key: selected_team_parent[k].key,
                      });
                      if (chk_teamExist.length == 0) {
                        let teamData =
                          this.teamByKey[selected_team_parent[k].key];
                        teamData.key = selected_team_parent[k].key;
                        teamData.color_code = teamData.color
                          ? teamData.color.replace(/#/g, "")
                          : "747474";
                        teamData.boss_pic = this.teamParentByKey[
                          selected_team_parent[k].key
                        ]
                          ? this.teamParentByKey[selected_team_parent[k].key]
                              .pic
                          : "";
                        teamData.boss_name = this.teamParentByKey[
                          selected_team_parent[k].key
                        ]
                          ? this.teamParentByKey[selected_team_parent[k].key]
                              .boss_firstname +
                            " " +
                            this.teamParentByKey[selected_team_parent[k].key]
                              .boss_lastname
                          : "";
                        teamData.count_member_team = this.teamParentByKey[
                          selected_team_parent[k].key
                        ]
                          ? this.teamParentByKey[selected_team_parent[k].key]
                              .sup.length
                          : 0;
                        this.teamSuggest.push(teamData);
                        this.teamSuggest_temp.push(teamData);
                      }
                    }
                  } else {
                    return;
                  }
                }
              }
            }
          } else {
            return;
          }
        }
      }
    },
    managerMembers() {
      if (
        Object.keys(this.managerMembers).length > 0 &&
        !this.completeManagerWarmingModal
      ) {
        Object.entries(this.managerMembers).forEach(([key, value]) => {
          this.reAssignManagerWarmingData.firstname =
            this.allArchiveData[key].firstname;
          this.reAssignManagerWarmingData.lastname =
            this.allArchiveData[key].lastname;
          this.reAssignManagerWarmingData.email =
            this.allArchiveData[key].email;
          this.reAssignManagerWarmingData.member = value.length;
          this.subCheckedData = value;
          this.managerSuggest = [];
          this.managerSuggest_temp = [];
          this.reAssignManager = "";
          if (this.allArchiveData[key].boss) {
            let bossKeyID = this.allArchiveData[key].boss.replace(/\./g, "||");
            if (this.membersByKey[bossKeyID]) {
              this.managerSuggest.push(this.membersByKey[bossKeyID]);
              this.managerSuggest_temp.push(this.membersByKey[bossKeyID]);
            }
          }

          this.reAssignManagerWarmingModal = true;
          return;
        });
      }
    },
    reviewUpdatesLoading(val) {
      if (val === false) {
        // default el-select (change email of manager to manager name)
        const delay = 500;
        setTimeout(() => {
          const reviewUpdates = this.$store.getters["integrations/reviewUpdates"];
          for (const i in reviewUpdates) {
            const item = reviewUpdates[i];
            const key = item.key;
            const refKey = `managerSelects[${key}]`;
            if (_.has(this.$refs, refKey)) {
              const ref = _.get(this.$refs, refKey);
              const manager = item.manager;
              if (!manager) continue;
              ref.selectedLabel = _.get(item, "manager_name", "");
              ref.selected.currentLabel = ref.selectedLabel;
            }
          }
        }, delay);
      }
    },
  },
  async beforeDestroy() {
    if (this.updateMember == true) {
      await this.$store.dispatch("main/getuser", true);
    }
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["newmember/inputSearch"];
      },
      set(value) {
        this.$store.commit("newmember/setinputSearch", {
          keyword: value,
          userstatus: this.type,
        });
      },
    },
    inputSearchArchive: {
      get() {
        return this.$store.getters["newmember/inputSearchArchive"];
      },
      set(value) {
        this.$store.commit("newmember/setinputSearchArchive", {
          keyword: value,
        });
      },
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    datamembers() {
      return this.$store.getters["newmember/datamembers"];
    },
    members() {
      // this.loadingMemberTable = ++this.loadingMemberTable;
      return this.$store.getters["newmember/members"];
    },
    team() {
      return this.$store.getters["newmember/team"];
    },
    dataexport() {
      return this.$store.getters["newmember/dataexport"];
    },
    page() {
      return this.$store.getters["newmember/page"];
    },
    pagearchive() {
      return this.$store.getters["newmember/pagearchive"];
    },
    results() {
      return this.$store.getters["newmember/results"];
    },
    resultsArchive() {
      return this.$store.getters["newmember/resultsArchive"];
    },
    modalMemberData() {
      return this.$store.getters["newmember/modalMemberData"];
    },
    membersByKey() {
      return this.$store.getters["newmember/membersByKey"];
    },
    membersArchiveByKey() {
      return this.$store.getters["newmember/membersArchiveByKey"];
    },
    bossByKey() {
      return this.$store.getters["newmember/bossByKey"];
    },
    teamByKey() {
      return this.$store.getters["newmember/teamByKey"];
    },
    teamParentByKey() {
      return this.$store.getters["newmember/teamParentByKey"];
    },
    membersArchive() {
      return this.$store.getters["newmember/membersArchive"];
    },
    membersArchiveAll() {
      return this.$store.getters["newmember/membersArchiveAll"];
    },
    incomplete() {
      return this.$store.getters["newmember/incomplete"];
    },
    loadingMemberTable() {
      return this.$store.getters["newmember/loadingMemberTable"];
    },
    loadingArchiveTable() {
      return this.$store.getters["newmember/loadingArchiveTable"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.validateForm.firstname || "",
        lastname: this.validateForm.lastname || "",
        teamColor: this.validateForm.house_color || "",
        house: this.validateForm.house || "",
        pic: this.validateForm.large_pic || false,
      };
      return passProfile;
    },
    membersByKey() {
      return this.$store.getters["newmember/membersByKey"];
    },
    allArchiveData() {
      return this.$store.getters["newmember/allArchiveData"];
    },
    managerMembers() {
      return this.$store.getters["newmember/managerMembers"];
    },
    riskData() {
      return this.$store.getters["newmember/riskData"];
    },
    loadingLoadMoreData() {
      return this.$store.getters["newmember/loadingLoadMoreData"];
    },
    powerData() {
      return this.$store.getters["newmember/powerData"];
    },
    archivedSchedule() {
      return this.$store.getters["newmember/archivedSchedule"];
    },
    timeZoneOption() {
      return this.$store.getters["newmember/timeZoneOption"];
    },
    locationOption() {
      return this.$store.getters["newmember/locationOption"];
    },
    allUser() {
      return this.$store.getters["main/allUser"];
    },
    updateMember() {
      return this.$store.getters["newmember/updateMember"];
    },
    /* Review Updates: xxx */
    reviewUpdates() {
      return this.$store.getters["integrations/reviewUpdates"]; 
    },
    reviewUpdatesAll() {
      return this.$store.getters["integrations/reviewUpdatesAll"];
    },
    reviewUpdatesLoading() {
      return this.$store.getters["integrations/reviewUpdatesLoading"];
    },
    reviewUpdatesTotal() {
      return this.$store.getters["integrations/reviewUpdatesTotal"];
    },
    reviewUpdatesPage() {
      return this.$store.getters["integrations/reviewUpdatesPage"];
    },
    reviewUpdatesByKey() {
      return this.$store.getters["integrations/reviewUpdatesByKey"];
    },
    pageReviewUpdates() {
      return this.$store.getters["integrations/pageReviewUpdates"];
    },
    teamOptions() {
      return this.createOptions("querySearchTeam");
    },
    managerOptions() {
      return this.createOptions("querySearchManager");
    },
  },
  methods: {
    createOptions(method) {
      const queryString = "";
      let items = [];
      const cb = (results) => {
        items = results;
      };
      this[method](queryString, cb);
      return items;
    },
    canEdit(item, target) {
      // HRIS
      if (item.source == "hris") {
        if (_.indexOf(["create", "update", "edit"], item.type) !== -1) {
          if (["team", "manager", "language", "country"].indexOf(target) !== -1) {
            return true;
          }
        } else if (item.type === "delete") {
          if (target == "archived_type") {
            return true;
          }
        }
      } else if (item.source == "app") {
        if (_.indexOf(["add_member", "direct_manager", "re_assign"], item.type) !== -1) {
          if (["team", "manager", "language", "country"].indexOf(target) !== -1) {
            return true;
          }
        } else if (item.type === "remove") {
          if (target == "archived_type") {
            return true;
          }
        }
      }
      return false;
    },
    getAppButtonLabelKey(type) {
      const scope = "members";
      if (type == "add_member") return `${scope}.ADD_MEMBER`;
      if (type == "remove") return `${scope}.ARCHIVE`;
      if (type == "direct_manager") return `${scope}.RE_ASSIGN`;
      if (type == "re_assign") return `${scope}.RE_ASSIGN`;

      return `${scope}.${type}`;
    },
    getImgIconOfPower(name) {
      return require("@/assets/images/components/profile/" + name + ".png");
    },
    ReAssignManagerActiveClick(item, index) {
      this.selectedManagerForReAssign = index;
      this.reAssignManager = item.email;
    },
    ManagerSelectedClick(item, index) {
      this.managerSuggest = [];
      this.managerSuggest.push(item);
      this.selectedManagerForReAssign = 0;
      this.reAssignManager = item.email;
    },
    handleInputManagerReAssign(queryString) {
      this.reAssignManager = "";
      this.selectedManagerForReAssign = null;
      if (queryString) {
        this.managerSuggest = [];
        let arrData = [];
        var links = this.datamembers["membersall"];
        var results = queryString
          ? links.filter(this.createFilterManager(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            let emailKey = results[i].email.replace(/\./g, "||");
            if (arrData.length < 8 && this.membersByKey[emailKey]) {
              arrData.push(this.membersByKey[emailKey]);
            }
          }
          this.managerSuggest = arrData;
        }
      } else {
        this.managerSuggest = this.managerSuggest_temp;
      }
    },
    createFilterManager(queryString) {
      return (link) => {
        if (
          link.firstname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !==
            this.reAssignManagerWarmingData.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.lastname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !==
            this.reAssignManagerWarmingData.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0 &&
          link.email.toLowerCase() !==
            this.reAssignManagerWarmingData.email.toLowerCase()
        ) {
          return true;
        }
      };
    },
    cancelReAssignManagerModal() {
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.reAssignManager = "";
      this.selectedManagerForReAssign = null;
      this.manager_assign_disp = "";
    },
    reAssignManagerModalSubmit() {
      if (!this.reAssignManager) {
        this.$message({
          showClose: true,
          message: "Please assign a manager",
          type: "error",
        });
        return false;
      } else {
        this.$confirm(
          "Are you sure you want to assign this manager?",
          "Confirm",
          {
            confirmButtonText: "Yes, confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            let chk_direct = false;
            let completeData = {};
            for (const i in this.subCheckedData) {
              if (this.subCheckedData[i].email == this.reAssignManager) {
                chk_direct = true;
                completeData.firstname = this.subCheckedData[i].firstname;
                completeData.lastname = this.subCheckedData[i].lastname;
                completeData.email = this.subCheckedData[i].email;
              }
            }
            this.$store.dispatch("newmember/ReAssignManagerSubmit", {
              memberData: this.subCheckedData,
              manager: this.reAssignManager,
            });
            this.subCheckedData = [];
            this.cancelReAssignManagerModal();
            this.reAssignManagerModal = false;
            if (chk_direct) {
              this.completeManagerWarmingData.firstname =
                completeData.firstname;
              this.completeManagerWarmingData.lastname = completeData.lastname;
              this.completeManagerWarmingData.email = completeData.email;
              this.completeManagerWarmingModal = true;
            }
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Manager assignement successful",
            });
          })
          // .then(() => {
          //   this.$store.dispatch("newteam/getTeams", this.user);
          //   this.$store.dispatch("membermanager/getMemberManager", this.user);
          // })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Manager assignment canceled",
            });
          });
      }
    },
    showReAssignManagerModal(type) {
      if (type == "reassign") {
        this.reAssignManagerWarmingModal = false;
        this.reAssignManagerModal = true;
      } else if (type == "complete") {
        this.completeManagerWarmingData.email;
        this.completeManagerWarmingModal = false;
        let keyId = this.completeManagerWarmingData.email.replace(/\./g, "||");
        if (this.membersByKey[keyId]) {
          let _data = this.membersByKey[keyId];
          _data.boss_team_name = "";
          _data.boss = "";
          _data.boss_pic = "";
          _data.boss_name = "";
          _data.boss_firstname = "";
          _data.boss_lastname = "";
          this.validateForm.dispmanager = "";
          this.rowClickEdit(_data, { columnKey: "showReAssignManagerModal" });
        }
      }
    },
    renderOptionSelect(creatElement, { column }) {
      let components = [];
      components.push(
        <el-dropdown-item command="thispage">
          Select {this.results.length < 10 ? this.results.length : 10} contacts
          on this page
        </el-dropdown-item>
      );
      if (this.results.length > 10) {
        components.push(
          <el-dropdown-item command="selectall">
            Select all {this.results.length} contacts
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="deselectall">Deselect all</el-dropdown-item>
      );
      return (
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="display: inline-block; float: right;"
          onCommand={this.handleCommand}
        >
          <div style="display: contents;">
            <el-checkbox
              v-model={this.checkAll[0]}
              onchange={this.checkAllFunc}
              style="display: inline-block; float: right; margin-right: 6px;"
            ></el-checkbox>
          </div>
          <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
        </el-dropdown>
      );
    },
    checkAllFunc(status, $event) {
      if (this.checkAll_temp) {
        this.$set(this.checkAll, 0, true);
      } else {
        this.$set(this.checkAll, 0, false);
      }
    },
    checkAllArchiveFunc(status, $event) {
      let filterArchiveSchedule = [];
      let filterArchive = [];
      if (this.checkAllArchive_temp) {
        this.$set(this.checkAllArchive, 0, true);
      } else {
        this.$set(this.checkAllArchive, 0, false);
        for (let key in this.membersArchiveByKey) {
          if (this.membersArchiveByKey[key].archiveSchedule) {
            filterArchiveSchedule.push(this.membersArchiveByKey[key]);
          } else {
            filterArchive.push(this.membersArchiveByKey[key]);
          }
        }
        if (filterArchiveSchedule.length > 0 && filterArchive.length > 0) {
          this.selcetedArchiveScheduleBoth = true;
        } else {
          this.selcetedArchiveScheduleBoth = false;
        }
        if (filterArchiveSchedule.length > 0) {
          this.selcetedArchiveSchedule = false;
        } else {
          this.selcetedArchiveSchedule = true;
        }
      }
    },
    renderOptionSelectArchive(creatElement, { column }) {
      let components = [];
      components.push(
        <el-dropdown-item command="thispageArchive">
          Select{" "}
          {this.resultsArchive.length < 10 ? this.resultsArchive.length : 10}{" "}
          contacts on this page
        </el-dropdown-item>
      );
      if (this.resultsArchive.length > 10) {
        components.push(
          <el-dropdown-item command="selectallArchive">
            Select all {this.resultsArchive.length} contacts
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="deselectallArchive">
          Deselect all
        </el-dropdown-item>
      );
      return (
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="display: inline-block; float: right;"
          onCommand={this.handleCommandArchive}
        >
          <div style="display: contents;">
            <el-checkbox
              v-model={this.checkAllArchive[0]}
              onchange={this.checkAllArchiveFunc}
              style="display: inline-block; float: right; margin-right: 6px;"
            ></el-checkbox>
          </div>
          <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
        </el-dropdown>
      );
    },
    handleCommand(command) {
      let check = this.checked;
      if (command == "thispage") {
        let thisMemberPage = this.members;
        for (const i in thisMemberPage) {
          this.$set(this.checked, "key_" + thisMemberPage[i].key, true);
          let chk_checked = _.filter(this.checkedData, {
            key: thisMemberPage[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedData.push(thisMemberPage[i]);
          }
        }
        if (
          Object.keys(this.checked).filter((k) => this.checked[k] === true)
            .length == this.datamembers["membersall"].length
        ) {
          this.checkAll_temp = true;
          this.$set(this.checkAll, 0, true);
        }
      } else if (command == "selectall") {
        let allMember = this.results;
        for (const i in allMember) {
          this.$set(this.checked, "key_" + allMember[i].key, true);
          let chk_checked = _.filter(this.checkedData, {
            key: allMember[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedData.push(allMember[i]);
          }
        }
        if (
          Object.keys(this.checked).filter((k) => this.checked[k] === true)
            .length == this.datamembers["membersall"].length
        ) {
          this.checkAll_temp = true;
          this.$set(this.checkAll, 0, true);
        }
        // this.checkAll_temp = true;
        // this.$set(this.checkAll, 0, true);
      } else if (command == "deselectall") {
        for (const i in check) {
          this.$set(this.checked, i, false);
        }
        this.checkedData = [];
        this.checkAll_temp = false;
        this.$set(this.checkAll, 0, false);
      }
    },
    handleCommandArchive(command) {
      let check = this.checkedArchive;
      if (command == "thispageArchive") {
        let thisMemberPage = this.membersArchive;
        for (const i in thisMemberPage) {
          this.$set(this.checkedArchive, "key_" + thisMemberPage[i].key, true);
          let chk_checked = _.filter(this.checkedDataArchive, {
            key: thisMemberPage[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataArchive.push(thisMemberPage[i]);
          }
        }
        if (
          Object.keys(this.checkedArchive).filter(
            (k) => this.checkedArchive[k] === true
          ).length == this.membersArchiveAll.length
        ) {
          this.checkAllArchive_temp = true;
          this.$set(this.checkAllArchive, 0, true);
        }
      } else if (command == "selectallArchive") {
        let allMember = this.resultsArchive;
        for (const i in allMember) {
          this.$set(this.checkedArchive, "key_" + allMember[i].key, true);
          let chk_checked = _.filter(this.checkedDataArchive, {
            key: allMember[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataArchive.push(allMember[i]);
          }
        }
        if (
          Object.keys(this.checkedArchive).filter(
            (k) => this.checkedArchive[k] === true
          ).length == this.membersArchiveAll.length
        ) {
          this.checkAllArchive_temp = true;
          this.$set(this.checkAllArchive, 0, true);
        }
      } else if (command == "deselectallArchive") {
        for (const i in check) {
          this.$set(this.checkedArchive, i, false);
        }
        this.checkedDataArchive = [];
        this.checkAllArchive_temp = false;
        this.$set(this.checkAllArchive, 0, false);
      }
    },
    membersChecked(key) {
      let count = Object.keys(this.checked).filter(
        (k) => this.checked[k] === true
      ).length;
      if (this.checked["key_" + key] === true) {
        this.checkedData.push(this.membersByKey[key]);
      } else {
        const index = this.checkedData.findIndex((obj) => obj.key === key);
        this.checkedData.splice(index, 1);
      }
      if (count == 1) {
        this.id = this.checkedData[0].key;
      } else {
        this.id = "";
      }
      if (
        Object.keys(this.checked).filter((k) => this.checked[k] === true)
          .length == this.datamembers["membersall"].length
      ) {
        this.checkAll_temp = true;
        this.$set(this.checkAll, 0, true);
      } else {
        this.checkAll_temp = false;
        this.$set(this.checkAll, 0, false);
      }
    },
    membersCheckedArchive(key) {
      let count = Object.keys(this.checkedArchive).filter(
        (k) => this.checkedArchive[k] === true
      ).length;
      if (this.checkedArchive["key_" + key] === true) {
        this.checkedDataArchive.push(this.membersArchiveByKey[key]);
      } else {
        const index = this.checkedDataArchive.findIndex(
          (obj) => obj.key === key
        );
        this.checkedDataArchive.splice(index, 1);
      }
      if (
        Object.keys(this.checkedArchive).filter(
          (k) => this.checkedArchive[k] === true
        ).length == this.membersArchiveAll.length
      ) {
        this.checkAllArchive_temp = true;
        this.$set(this.checkAllArchive, 0, true);
      } else {
        this.checkAllArchive_temp = false;
        this.$set(this.checkAllArchive, 0, false);
      }
      let filterArchiveSchedule = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return currentObject.archiveSchedule;
        }
      );
      let filterArchive = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return !currentObject.archiveSchedule;
        }
      );

      if (filterArchiveSchedule.length > 0 && filterArchive.length > 0) {
        this.selcetedArchiveScheduleBoth = true;
      } else {
        this.selcetedArchiveScheduleBoth = false;
      }
      if (filterArchiveSchedule.length > 0) {
        this.selcetedArchiveSchedule = false;
      } else {
        this.selcetedArchiveSchedule = true;
      }
    },
    statusClick(type) {
      if (type == "all") {
        document.getElementById("userStatus").innerHTML =
          "All (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersall"]
              ? this.datamembers["membersall"].length
              : "0"
          ) +
          ")";
      } else if (type == "active") {
        document.getElementById("userStatus").innerHTML =
          "Active (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersact"]
              ? this.datamembers["membersact"].length
              : "0"
          ) +
          ")";
      } else if (type == "inactive") {
        document.getElementById("userStatus").innerHTML =
          "Inactive (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersinact"]
              ? this.datamembers["membersinact"].length
              : "0"
          ) +
          ")";
      } else if (type == "new") {
        document.getElementById("userStatus").innerHTML =
          "New (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersnew"]
              ? this.datamembers["membersnew"].length
              : "0"
          ) +
          ")";
      } else if (type == "invited") {
        document.getElementById("userStatus").innerHTML =
          "Invited (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersinvited"]
              ? this.datamembers["membersinvited"].length
              : "0"
          ) +
          ")";
      }
      this.type = type;
      this.$store.dispatch("newmember/statusChange", type);
    },
    handleCurrentChange(val) {
      this.$store.dispatch("newmember/currentChange", val);
    },
    handleArchiveCurrentChange(val) {
      this.$store.dispatch("newmember/archiveCurrentChange", val);
    },
    sort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("newmember/sortMember", [column.property, order]);
      }
      this.handleCurrentChange(this.page);
    },
    sortArchive({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("newmember/sortMemberArchive", [
          column.property,
          order,
        ]);
      }
    },
    clickExport() {
      this.showSnackbar = true;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 2000);
    },
    // Review Updates: xxx
    getReviewUpdatesTotal() {
      this.$store.dispatch("integrations/getReviewUpdatesTotal", this.user, { root: true });
    },
    clickReviewUpdates() {
      this.reviewUpdatesModalStatus = !this.reviewUpdatesModalStatus;
      this.handleCommandReviewUpdates('deselectallReviewUpdates');
      this.$store.dispatch("integrations/getReviewUpdates", this.user, { root: true });
    },
    cancelReviewUpdates() {
      // console.log("cancelReviewUpdates()");
    },
    sortReviewUpdates({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("integrations/sortReviewUpdates", [
          column.property,
          order,
        ]);
      }
    },
    handleReviewUpdatesCurrentChange(val) {
      this.$store.dispatch("integrations/reviewUpdatesCurrentChange", val);
    },
    handleCommandReviewUpdates(command) {
      let check = this.checkedReviewUpdates;
      if (command == "thispageReviewUpdates") {
        let thisMemberPage = this.reviewUpdates;
        for (const i in thisMemberPage) {
          this.$set(this.checkedReviewUpdates, "key_" + thisMemberPage[i].key, true);
          let chk_checked = _.filter(this.checkedDataReviewUpdates, {
            key: thisMemberPage[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataReviewUpdates.push(thisMemberPage[i]);
          }
        }
        if (
          Object.keys(this.checkedReviewUpdates).filter(
            (k) => this.checkedReviewUpdates[k] === true
          ).length == this.reviewUpdatesTotal
        ) {
          this.checkAllReviewUpdates_temp = true;
          this.$set(this.checkAllReviewUpdates, 0, true);
        }
      } else if (command == "selectallReviewUpdates") {
        let allMember = this.reviewUpdatesAll;
        for (const i in allMember) {
          this.$set(this.checkedReviewUpdates, "key_" + allMember[i].key, true);
          let chk_checked = _.filter(this.checkedDataReviewUpdates, {
            key: allMember[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataReviewUpdates.push(allMember[i]);
          }
        }
        if (
          Object.keys(this.checkedReviewUpdates).filter(
            (k) => this.checkedReviewUpdates[k] === true
          ).length == this.reviewUpdatesTotal
        ) {
          this.checkAllReviewUpdates_temp = true;
          this.$set(this.checkAllReviewUpdates, 0, true);
        }
      } else if (command == "deselectallReviewUpdates") {
        for (const i in check) {
          this.$set(this.checkedReviewUpdates, i, false);
        }
        this.checkedDataReviewUpdates = [];
        this.checkAllReviewUpdates_temp = false;
        this.$set(this.checkAllReviewUpdates, 0, false);
      }

      this._updateBulkActions();
    },
    async ignoreReviewUpdates(key) {
      const keys = Array.isArray(key) ? key : [key];

      const reviewUpdatesAll = this.$store.getters["integrations/reviewUpdatesAll"];
      const items = _.filter(reviewUpdatesAll, function(item) { return keys.indexOf(item.key) !== -1 });

      if (!items.length) return;

      const doConfirm = true;
      const confirmTitle = "Are you sure you want to ignore review udpates?";
      const confirmSuccess = "Success";
      const confirmCancel = "Canceled";

      const run = async () => {
        this.$store.dispatch("integrations/beginBulkUpdates", null, {root: true});
        for (const i in items) {
          const item = items[i];
          this.checkedReviewUpdates["key_" + item.key] = false;
          this.membersCheckedReviewUpdates(item.key);
          await this.$store.dispatch("integrations/updateReviewUpdates", {
            key: item.key,
            status: "ignore",
          });
        }
        this.$store.dispatch("integrations/endBulkUpdates", keys, {root: true});
      };

      if (doConfirm) {
        this.$confirm(
        confirmTitle,
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          run();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: confirmSuccess,
          });
        })

        .catch((e) => {
          console.log(e, "e");
          this.$message({
            type: "info",
            message: confirmCancel,
          });
        });
      } else {
        run();
      }
    },
    async runCommandReviewUpdates(key) {
      const keys = Array.isArray(key) ? key : [key];
      
      const reviewUpdatesIgnorePendingStatus = this.$store.getters["integrations/reviewUpdatesIgnorePendingStatus"];
      const reviewUpdatesAll = this.$store.getters["integrations/reviewUpdatesAll"];
      const items = _.filter(reviewUpdatesAll, function(item) { return keys.indexOf(item.key) !== -1 });

      if (!items.length) return;

      let isAddUser = false;
      let isUpdateUser = false;
      let isArchiveUser = false;
      let isChangeManager = false;

      // validate
      const doValidate = true; // for quick testing
      let error = false;
      let errorMsg = "";
      if (doValidate) {
        for (const i in items) {
          const item = items[i];
        // _.each(items,  (item) => {
          if (error) break;

          if (!reviewUpdatesIgnorePendingStatus) {
            if (item.status !== "pending") break;
          }
          
          const source = item.source.toLowerCase()
          if (source == "hris") {
            if (item.type == "create" || item.type == "update" || item.type == "edit") {
              isAddUser = true;
              if (item.type == "update") {
                isAddUser = false;
                isUpdateUser = true;
              }

              // prevent error from internal save function
              const newId = item.email.replace(/\./g, "||");
              const archivedUser = (await firebase.database().ref(`/users_employee_exit/${newId}`).once('value')).val();
              if (archivedUser) {
                error = true;
                errorMsg = `The email (${item.email}) is already in use (as an archived member)`;
                console.log(errorMsg, "errorMsg");
                break;
              }

              if (!item.team.length) {
                error = true;
                errorMsg = "Please assign a team for " + item.email;
                break;
              }
              if (!item.manager.length) {
                error = true;
                errorMsg = "Please select a manager for " + item.email;
                break;
              }
            } else if (item.type == "delete") {
              isArchiveUser = true;
              if (!item.archived_type.length) {
                // console.log(item, "item error of archived type");
                error = true;
                errorMsg = "Please select archived type for " + item.email;
                break;
              }
            }
          }

          // @todo direct_manager, add_member, remove, re_assign
          //       common code in the future
          if (source == "app") {
            if (item.type == "add_member" || item.type == "direct_manager" || item.type == "re_assign") {
              isAddUser = true;
              if (item.type != "add_member") {
                isAddUser = false;
                isUpdateUser = true;
              }

              // prevent error from internal save function
              const newId = item.email.replace(/\./g, "||");
              const archivedUser = (await firebase.database().ref(`/users_employee_exit/${newId}`).once('value')).val();
              if (archivedUser) {
                error = true;
                errorMsg = `The email (${item.email}) is already in use (as an archived member)`;
                console.log(errorMsg, "errorMsg");
                break;
              }

              if (!item.team.length) {
                error = true;
                errorMsg = "Please assign a team for " + item.email;
                break;
              }
              if (!item.manager.length) {
                error = true;
                errorMsg = "Please select a manager for " + item.email;
                break;
              }

            } else if (item.type == "remove") {
              isArchiveUser = true;
              if (!item.archived_type.length) {
                console.log(item, "item error of archived type");
                error = true;
                errorMsg = "Please select archived type for " + item.email;
                break;
              }
            }
          }

          this.validateForm.boss_team_name = "";
          this.validateForm.boss = "";
          this.validateForm.boss_pic = "";
          this.validateForm.boss_firstname = "";
          this.validateForm.boss_lastname = "";

          // check manager and team
          const managerKey = item.manager.replace(/\./g, '||');
          const manager = _.find(this.managerOptions, { key: managerKey });
          if (manager) {
            this.validateForm.boss_team_name = manager.team_name;
            this.validateForm.boss = manager.email;
            this.validateForm.boss_pic = manager.pic;
            this.validateForm.boss_firstname = manager.firstname;
            this.validateForm.boss_lastname = manager.lastname;
          }

          this.validateForm.email = item.email;
          this.validateForm.team = item.team;
          this.validateForm.manager = item.manager;

          // @see handleSelectManager
          this.handleSelectManager(manager);

          if (this.validateForm.dispmanager.length) {
            error = true;
            errorMsg = this.validateForm.dispmanager;
            break;
          }

          this.handleSelectTeam(_.cloneDeep(item));
          if (this.validateForm.dispmanager.length) {
            error = true;
            errorMsg = this.validateForm.dispmanager;
            break;
          }

        // });
        }
      }

      const doLogError = false;
      if (doLogError) {
        console.log(error, "error");
        console.log(errorMsg, "errorMsg");
      }

      if (error) {
        this.$message.error(errorMsg);
        return;
      }

      // Confirmation
      const doConfirm = true;

      let confirmTitle = "Are you sure you want to update information?";
      let confirmSuccess = "Success";
      let confirmCancel = "Canceled";
      if (isAddUser) {
        confirmTitle = "Are you sure you want to create member";
        confirmSuccess = "Member created";
        confirmCancel = "Canceled";
      } else if (isUpdateUser) {
        confirmTitle = "Are you sure you want to edit member";
        confirmSuccess = "Member edited";
        confirmCancel = "Canceled";
      } else if (isArchiveUser) {
        confirmTitle = "Are you sure you want to archive this member account?";
        confirmSuccess = "Member account archived";
        confirmCancel = "Canceled";
      } else if (isChangeManager) {
        confirmTitle = "Are you sure you want to assign this manager?";
        confirmSuccess = "Manager assignement successful";
        confirmCancel = "Manager assignment canceled";
      }

      const run = async (cb = () => {}) => {
        const allUser = this.$store.getters["main/allUser"];
        const teamOptions = this.teamOptions;
        const managerOptions = this.managerOptions;

        this.$store.dispatch("integrations/beginBulkUpdates", null, {root: true});

        // process
        for (const i in items) {
          const item = items[i];
          

          if (!reviewUpdatesIgnorePendingStatus) {
            if (item.status !== "pending") return;
          }
          
          const emailKey = item.email.replace(/\./g, "||");
          const source = item.source.toLowerCase();

          let isAddUser = false;
          let isUpdateUser = false;
          let isArchiveUser = false;
          let isChangeManager = false;

          if (source == "hris") {
            if (item.type == "create") {
              isAddUser = true;
            } else if (item.type == "update" || item.type == "edit") {
              isUpdateUser = true;
            } else if (item.type == "delete") {
              isArchiveUser = true;
            }
          } else if (source == "app") {
            if (item.type == "add_member") {
              isAddUser = true;
            } else if (item.type == "direct_manager" || item.type == "re_assign") {
              isChangeManager = true;
              isUpdateUser = true;
            } else if (item.type == "remove") {
              isArchiveUser = true;
            }
          }

          if (isAddUser || isUpdateUser) {

            // @see this.addMember();
            this.mode = allUser.hasOwnProperty(emailKey) ? "edit" : "";
            this.cancelAdd();
            // this.dialogFormVisible = true;
            this.scheduledArchive = false;

            // copy values
            this.validateForm.firstname = item.firstname;
            this.validateForm.lastname = item.lastname;
            this.validateForm.email = item.email;

            // @see handleSelectTeam()
            const team = _.find(teamOptions, { key: item.team });
            if (team) {
              let color = team.color ? team.color.replace(/#/g, "") : "";
              this.validateForm.team = team.key;
              this.validateForm.team_color = color;

              this.validateForm.dispteam = team.name; // fixed, none finding in function to create
            }

            // @see handleSelectManager()
            const managerKey = item.manager.replace(/\./g, "||");
            const manager = _.find(managerOptions, { key: managerKey });
            if (manager) {
              this.validateForm.boss_team_name = manager.team_name;
              this.validateForm.boss = manager.email;
              this.validateForm.boss_pic = manager.pic;
              this.validateForm.boss_firstname = manager.firstname;
              this.validateForm.boss_lastname = manager.lastname;
            }

            if (_.has(item, "country", "TH")) {
              this.validateForm.country = item.country;
            }

            if (_.has(item, "language", "th")) {
              this.validateForm.language = item.language;
            }

            // @see saveMember()
            if (this.mode == "edit") {

              // don't change user type
              this.validateForm.user_type = _.get(allUser, `${emailKey}.user_type`, "user");

              //*
              this.id = this.validateForm.email.replace(/\./g, "||");
              this.$store
                .dispatch("newmember/updateMember", {
                  id: this.id,
                  form: this.validateForm,
                })
                .then(() => {
                  this.dialogFormVisible = false;
                  this.cancelAdd();
                });
              // this.$message({
              //   type: "success",
              //   message: "Member profile has been updated",
              // });f
              //*/
            } else {
              let ctemail = this.validateForm.email.toLowerCase();
              const newId = ctemail.replace(/\./g, "||");
              firebase
                .database()
                .ref(`/users/${newId}`)
                .once("value", (snapshot) => {
                  if (snapshot.val()) {
                    // this.$message.error("This email has already been registered.");
                    error = true;
                    errorMsg = "This email has already been registered.";
                  } else {
                    firebase
                      .database()
                      .ref(`/users_employee_exit/${newId}`)
                      .once("value", (snapshot) => {
                        if (snapshot.val()) {
                          // this.$message.error(
                          //   "The email is already in use (as an archived member)"
                          // );
                          error = true;
                          errorMsg = "The email is already in use (as an archived member)";
                        } else {
                          this.$store
                            .dispatch("newmember/createMember", {
                              form: this.validateForm,
                              invite: this.checkedAutoSendInvit,
                            })
                            .then(() => {
                              this.dialogFormVisible = false;
                              this.cancelAdd();
                            });
                          /*
                          this.$message({
                            type: "success",
                            message: "New member has been created",
                          });
                          //*/
                        }
                      });
                  }
                });
            }

          } else if (isArchiveUser) {
            //*
            this.id = emailKey;
            this.dateAcchivePicker = "";
            // this.archiveMemberClick(item.archived_type);

            const type = item.archived_type;
            if (
              new Date(this.dateAcchivePicker) <= new Date() ||
              !this.dateAcchivePicker
            ) {
              this.$store.dispatch("newmember/archiveMember", {
                id: this.id,
                type: type,
              });
            } else {
              this.$store.dispatch("newmember/setTimeArchiveMember", {
                id: this.id,
                archive_date: this.dateAcchivePicker,
                type: type,
              });
            }
            this.dialogFormVisible = false;
            this.cancelAdd();

            //*/
          }
          
          /*
          else if (source == "app") {

            const user = _.get(allUser, emailKey, {});
            if (user && !user.key) {
              user.key = emailKey;
            }
            const checkedData = [user];
            const assignManager = item.email_request;

            this.$store.dispatch("newmember/assignManagerSubmit", {
              memberData: checkedData,
              manager: assignManager,
            });
          }
          //*/

          if (error) {
            this.$message.error(errorMsg);
          } else {
            this.checkedReviewUpdates["key_" + item.key] = false;
            this.membersCheckedReviewUpdates(item.key);
            await this.$store.dispatch("integrations/updateReviewUpdates", {
              key: item.key,
              status: "success",
            });
          }
        }

        this.$store.dispatch("integrations/endBulkUpdates", keys, {root: true});
        cb();
      }

      if (doConfirm) {
        this.$confirm(
        confirmTitle,
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          run(() => {
            this.$message({
              type: "success",
              message: confirmSuccess,
            });
          });
        })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: confirmSuccess,
          // });
        })

        .catch((e) => {
          console.log(e, "e");
          this.$message({
            type: "info",
            message: confirmCancel,
          });
        });
      } else {
        run();
      }
    },
    async bulkCommandReviewUpdates(action) {
      let keys = [];
      let filter;
      switch (action) {
        case "reAssignManager":
          filter = {source: "app", type: "direct_manager"};
          break;
        case "addUser":
          filter = {source: "hris", type: "create"};
          break;
        case "archive":
          filter = {source: "hris", type: "delete"};
          break;
      }
      if (action == "ignore") {
        keys = this.checkedDataReviewUpdates.map((item) => {
          return item.key;
        });
        await this.ignoreReviewUpdates(keys);
      } else {
        keys = _.filter(this.checkedDataReviewUpdates, filter).map((item) => {
          return item.key;
        });
        await this.runCommandReviewUpdates(keys);
      }
    },
    checkAllReviewUpdatesFunc(status, $event) {
      if (this.checkAllReviewUpdates_temp) {
        this.$set(this.checkAllReviewUpdates, 0, true);
      } else {
        this.$set(this.checkAllReviewUpdates, 0, false);
      }
    },
    renderOptionSelectReviewUpdates(creatElement, { column }) {
      let components = [];
      components.push(
        <el-dropdown-item command="thispageReviewUpdates">
          Select{" "}
          {this.reviewUpdatesTotal < 10 ? this.reviewUpdatesTotal : 10}{" "}
          contacts on this page
        </el-dropdown-item>
      );
      if (this.reviewUpdatesTotal > 10) {
        components.push(
          <el-dropdown-item command="selectallReviewUpdates">
            Select all {this.reviewUpdatesTotal} contacts
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="deselectallReviewUpdates">
          Deselect all
        </el-dropdown-item>
      );
      return (
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="display: inline-block; float: right;"
          onCommand={this.handleCommandReviewUpdates}
        >
          <div style="display: contents;">
            <el-checkbox
              v-model={this.checkAllReviewUpdates[0]}
              onchange={this.checkAllReviewUpdatesFunc}
              style="display: inline-block; float: right; margin-right: 6px;"
            ></el-checkbox>
          </div>
          <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
        </el-dropdown>
      );
    },
    _updateBulkActions() {
      this.bulkIgnoreStatus = this.checkedDataReviewUpdates.length > 0;
      this.bulkAddUserStatus = 
        (_.filter(this.checkedDataReviewUpdates, {source: "hris", type: "create"}).length + 
        _.filter(this.checkedDataReviewUpdates, {source: "app", type: "add_member"}).length) > 0;
      this.bulkArchiveStatus = (_.filter(this.checkedDataReviewUpdates, {source: "hris", type: "delete"}).length +
        _.filter(this.checkedDataReviewUpdates, {source: "app", type: "remove"}).length) > 0;
      this.bulkReAssignManagerStatus = (_.filter(this.checkedDataReviewUpdates, {source: "app", type: "direct_manager"}).length +
        _.filter(this.checkedDataReviewUpdates, {source: "app", type: "re_assign"}).length) > 0;
    },
    membersCheckedReviewUpdates(key) {
      let count = Object.keys(this.checkedReviewUpdates).filter(
        (k) => this.checkedReviewUpdates[k] === true
      ).length;
      if (this.checkedReviewUpdates["key_" + key] === true) {
        this.checkedDataReviewUpdates.push(this.reviewUpdatesByKey[key]);
      } else {
        const index = this.checkedDataReviewUpdates.findIndex(
          (obj) => obj.key === key
        );
        this.checkedDataReviewUpdates.splice(index, 1);
      }
      this._updateBulkActions();
    },
    addMember() {
      this.mode = "";
      this.cancelAdd();
      this.dialogFormVisible = true;
      this.scheduledArchive = false;
    },
    cancelAdd() {
      this.validateForm.large_pic = "";
      this.validateForm.firstname = "";
      this.validateForm.lastname = "";
      this.validateForm.email = "";
      this.validateForm.dispteam = "";
      this.validateForm.team_color = "";
      this.validateForm.dispboss = "";
      this.validateForm.team = "";
      this.validateForm.boss_team_name = "";
      this.validateForm.boss = "";
      this.validateForm.tmp_boss = "";
      this.validateForm.boss_pic = "";
      this.validateForm.boss_firstname = "";
      this.validateForm.boss_lastname = "";
      this.validateForm.language = "th";
      this.validateForm.user_type = "user";
      (this.validateForm.country = "TH"),
        (this.validateForm.time_zone = "+07:00"),
        // this.validateForm.invite = true;
        (this.validateForm.status = "new");
      this.validateForm.to_now = "";
      this.validateForm.streak_count = 0;
      this.validateForm.super_feedback_count = 0;
      this.validateForm.medal = [];
      this.validateForm.coin = 0;
      this.validateForm.gem = 0;
      this.validateForm.house = "";
      this.validateForm.joined = "";
      this.validateForm.joined_tooltips = [];
      this.validateForm.dispmanager = "";
      this.validateForm.introduce = "";
      (this.validateForm.culture_add_percentile = ""),
        (this.switchToArchive = false);
      this.checkedAutoSendInvit = true;
      this.activeName = "powers";
      this.directReportsData = {};
      this.activeProfileTab = "information";
      this.scheduledArchive = false;
      this.$store.commit("newmember/setModalMemberData", []);
      this.dateAcchivePicker = "";
      let check = this.checked;
      for (const i in check) {
        this.$set(this.checked, i, false);
      }

      this.checkedData = [];
      this.$set(this.checkAll, 0, false);
      this.checkAll_temp = false;
    },
    cancelAddArchive() {
      let check = this.checkedArchive;
      for (const i in check) {
        this.$set(this.checkedArchive, i, false);
      }
      this.checkedDataArchive = [];
      this.$set(this.checkAllArchive, 0, false);
      this.checkAllArchive_temp = false;
    },
    cancelDialog() {
      this.dateAcchivePicker = "";
      this.dialogFormVisible = false;
      this.directReportsData = {};
      this.$store.commit("newmember/setModalMemberData", []);
      this.$store.dispatch("newmember/clearDate");
      this.cancelAdd();
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgUrlMem(pic) {
      var images = require.context(
        "../../assets/images/members/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    getImgUrlSet(pic) {
      var images = require.context(
        "../../assets/images/settings/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    querySearchTeam(queryString, cb) {
      //var links = this.links;
      var links = this.team;
      var results = queryString
        ? links.filter(this.createFilterTeam(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterTeam(queryString) {
      return (link) => {
        return link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelectTeam(item) {
      item.email = this.validateForm.boss;
      this.validateForm.dispmanager = "";
      if (this.validateForm.email && item.email) {
        // check loop
        let arrUserRole = [];
        let bossTemp = "";
        let chkLoopErr = false;
        arrUserRole[this.validateForm.email] = this.validateForm.email;
        arrUserRole[item.email] = item.email;
        let emailKey = item.email.replace(/\./g, "||");
        bossTemp =
          this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
            ? this.membersByKey[emailKey].boss
            : "";
        if (bossTemp) {
          do {
            if (arrUserRole[bossTemp]) {
              chkLoopErr = true;
            } else {
              arrUserRole[bossTemp] = bossTemp;
              let bossKey = bossTemp.replace(/\./g, "||");
              bossTemp =
                this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
                  ? this.membersByKey[bossKey].boss
                  : "";
              if (bossTemp && arrUserRole[bossTemp]) {
                chkLoopErr = true;
              }
            }
          } while (
            bossTemp &&
            arrUserRole[bossTemp] == undefined &&
            chkLoopErr == false
          );
        }
        if (chkLoopErr) {
          this.validateForm.dispmanager =
            "⚠️ Managers cannot report to their direct report or below";
        }
        // End Check Loop
      }
      if (
        this.validateForm.boss &&
        item.key &&
        this.validateForm.dispmanager == ""
      ) {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: item.key,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (teamMember[i]["email"] !== this.validateForm.email && teamMember[i]["boss"]) {
              let bossKey = teamMember[i]["boss"].replace(/\./g, "||");
              if(this.membersByKey[bossKey]){
                bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
              }
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = item.email.replace(/\./g, "||");
            if (
              bosscheck[item.email] == undefined &&
              bosscheck[this.validateForm.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
              } else {
                this.validateForm.dispmanager =
                  "⚠️ Managers must have their own team";
              }
            }
          }
          // if((Object.keys(bosscheck)).length >= 1){
          //   if(bosscheck[item.email] == undefined && bosscheck[this.validateForm.email] == undefined){
          //     this.validateForm.dispmanager = "⚠️ Managers must have their own team"
          //   }
          // }
        }
      }
      let color = item.color ? item.color.replace(/#/g, "") : "";
      this.validateForm.team = item.key;
      this.validateForm.team_color = color;
    },
    handleInputTeam(value) {
      if (!value) {
        this.validateForm.team_color = "";
        this.validateForm.dispmanager = "";
      }
    },
    querySearchManager(queryString, cb) {
      var links = this.datamembers["membersall"] || [];
      var results = links.filter(this.createFilterManager(queryString));
      cb(results);
    },
    createFilterManager(queryString) {
      return (link) => {
        if (
          link.firstname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.lastname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.hasOwnProperty("team_name") &&
          link.team_name.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.team_name.toLowerCase() !==
            this.validateForm.boss_team_name.toLowerCase()
        ) {
          return true;
        }
      };
    },
    handleSelectManager(item) {
      this.validateForm.dispmanager = "";
      if (this.validateForm.email) {
        // check loop
        let arrUserRole = [];
        let bossTemp = "";
        let chkLoopErr = false;
        arrUserRole[this.validateForm.email] = this.validateForm.email;
        arrUserRole[item.email] = item.email;
        let emailKey = item.email.replace(/\./g, "||");
        bossTemp =
          this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
            ? this.membersByKey[emailKey].boss
            : "";
        if (bossTemp) {
          do {
            if (arrUserRole[bossTemp]) {
              chkLoopErr = true;
            } else {
              arrUserRole[bossTemp] = bossTemp;
              let bossKey = bossTemp.replace(/\./g, "||");
              bossTemp =
                this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
                  ? this.membersByKey[bossKey].boss
                  : "";
              if (bossTemp && arrUserRole[bossTemp]) {
                chkLoopErr = true;
              }
            }
          } while (
            bossTemp &&
            arrUserRole[bossTemp] == undefined &&
            chkLoopErr == false
          );
        }
        if (chkLoopErr) {
          this.validateForm.dispmanager =
            "⚠️ Managers cannot report to their direct report or below";
        }
        // End Check Loop
      }
      if (this.validateForm.team && this.validateForm.dispmanager == "") {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: this.validateForm.team,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (teamMember[i]["email"] !== this.validateForm.email && teamMember[i]["boss"]) {
              let bossKey = teamMember[i]["boss"].replace(/\./g, "||");
              if(this.membersByKey[bossKey]){
                bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
              }
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = item.email.replace(/\./g, "||");
            if (
              bosscheck[item.email] == undefined &&
              bosscheck[this.validateForm.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
              } else {
                this.validateForm.dispmanager =
                  "⚠️ Managers must have their own team";
              }
            }
          }
          // if((Object.keys(bosscheck)).length >= 1){
          //   if(bosscheck[item.email] == undefined && bosscheck[this.validateForm.email] == undefined){
          //     this.validateForm.dispmanager = "⚠️ Managers must have their own team"
          //   }
          // }
        }
      }
      this.validateForm.boss_team_name = item.team_name;
      this.validateForm.boss = item.email;
      this.validateForm.boss_pic = item.pic;
      this.validateForm.boss_firstname = item.firstname;
      this.validateForm.boss_lastname = item.lastname;
    },
    handleInputManager(value) {
      if (!value) {
        this.validateForm.boss_team_name = "";
        this.validateForm.boss = "";
        this.validateForm.boss_pic = "";
        this.validateForm.boss_firstname = "";
        this.validateForm.boss_lastname = "";
        this.validateForm.dispmanager = "";
      }
    },
    handleInputManagerAssign(queryString) {
      this.assignManager = "";
      this.selectedManagerForAssign = null;
      if (queryString) {
        this.managerSuggest = [];
        let arrData = [];
        var links = this.datamembers["membersall"];
        var results = queryString
          ? links.filter(this.createFilterManager(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            let emailKey = results[i].email.replace(/\./g, "||");
            let chk_self = _.filter(this.checkedData, { key: emailKey });
            if (
              arrData.length < 8 &&
              chk_self.length == 0 &&
              this.membersByKey[emailKey]
            ) {
              arrData.push(this.membersByKey[emailKey]);
            }
          }
          this.managerSuggest = arrData;
        }
      } else {
        this.managerSuggest = this.managerSuggest_temp;
      }
    },
    handleInputTeamAssign(queryString) {
      this.assignTeam = "";
      this.selectedTeamForAssign = null;
      if (queryString) {
        this.teamSuggest = [];
        let arrData = [];
        var links = this.team;
        var results = queryString
          ? links.filter(this.createFilterTeam(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            if (arrData.length < 8 && this.teamByKey[results[i].key]) {
              let teamId = results[i].key;
              let teamData = this.teamByKey[teamId];
              teamData.key = teamId;
              teamData.color_code = teamData.color
                ? teamData.color.replace(/#/g, "")
                : "747474";
              teamData.boss_pic = this.teamParentByKey[teamId]
                ? this.teamParentByKey[teamId].pic
                : "";
              teamData.boss_name = this.teamParentByKey[teamId]
                ? this.teamParentByKey[teamId].boss_firstname +
                  " " +
                  this.teamParentByKey[teamId].boss_lastname
                : "";
              teamData.count_member_team = this.teamParentByKey[teamId]
                ? this.teamParentByKey[teamId].sup.length
                : 0;
              arrData.push(teamData);
            }
          }
          this.teamSuggest = arrData;
        }
      } else {
        this.teamSuggest = this.teamSuggest_temp;
      }
    },
    validateEmoji(value) {
      const withEmojis = /\p{Extended_Pictographic}/gu;
      return withEmojis.test(value);
    },
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    archiveMemberType(type) {
      // console.log("archiveMemberType", type);
      // @TODO: call this function `archiveMemberClick`
      this.archiveMemberClick(type);
    },
    archiveMemberClick(type) {
      this.$confirm(
        "Are you sure you want to archive this member account?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (
            new Date(this.dateAcchivePicker) <= new Date() ||
            !this.dateAcchivePicker
          ) {
            this.$store.dispatch("newmember/archiveMember", {
              id: this.id,
              type: type,
            });
          } else {
            this.$store.dispatch("newmember/setTimeArchiveMember", {
              id: this.id,
              archive_date: this.dateAcchivePicker,
              type: type,
            });
          }
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Member account archived",
          });
        })

        .catch((e) => {
          console.log(e, "e");
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    archiveArrMemberClick() {
      if (this.checkedData.length > 1) {
        this.archiveMutipleMemberModal = true;
      } else {
        this.switchToArchive = true;
        this.dialogFormVisible = true;
      }
      // this.$confirm(
      //   "Are you sure you want to archive this member?",
      //   "Warning",
      //   {
      //     confirmButtonText: "Yes, confirm",
      //     cancelButtonText: "Cancel",
      //     type: "warning",
      //     center: true,
      //   }
      // )
      //   .then(() => {
      //     this.$store.dispatch("newmember/archiveArrMember", this.checkedData);
      //     this.dialogFormVisible = false;
      //     this.cancelAdd();
      //   })
      //   .then(() => {
      //     this.$message({
      //       type: "success",
      //       message: "Account Archived",
      //     });
      //   })
      //   // .then(() => {
      //   //   this.$store.dispatch("newteam/getTeams", this.user);
      //   //   this.$store.dispatch("membermanager/getMemberManager", this.user);
      //   // })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "Canceled",
      //     });
      //   });
    },
    getDayOfWeek() {
      if (this.dateAcchivePicker) {
        const a = new Date(this.dateAcchivePicker);
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        return days[a.getDay()];
      }
      return "";
    },
    archiveMemberByGroupType(type) {
      //console.log(type)
      this.confirmArchiveMember(type);
      // @TODO: call this function `confirmArchiveMember`
    },
    confirmArchiveMember(type) {
      this.$confirm(
        "Are you sure you want to archive this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (
            new Date(this.dateAcchivePicker) <= new Date() ||
            !this.dateAcchivePicker
          ) {
            this.$store.dispatch("newmember/archiveArrMember", {
              obj: this.checkedData,
              type: type,
            });
          } else {
            this.$store.dispatch("newmember/setTimeArchiveArrMember", {
              arr: this.checkedData,
              archive_date: this.dateAcchivePicker,
              type: type,
            });
          }
          let check = this.checked;
          for (const i in check) {
            this.$set(this.checked, i, false);
          }
          this.archiveMutipleMemberModal = false;
          this.cancelDialog();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Archived",
          });
        });
      // .then(() => {
      //   this.$store.dispatch("newteam/getTeams", this.user);
      //   this.$store.dispatch("membermanager/getMemberManager", this.user);
      // })
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "Canceled",
      //   });
      // });

      // this.$message({
      //         type: "success",
      //         message: "Account Archived",
      //       });
      //       // this.archiveMutipleMemberModal = false;
      //       this.switchToArchive = false;
      //       this.cancelDialog();
    },
    saveMember() {
      if (
        !this.validateForm.firstname.replace(/ /g, "") ||
        !this.validateForm.lastname.replace(/ /g, "") ||
        !this.validateForm.email.replace(/ /g, "") ||
        !this.validateForm.dispteam.replace(/ /g, "")
      ) {
        this.$message({
          showClose: true,
          message: "Please fill in all the input fields before saving changes",
          type: "error",
        });
        return false;
      } else if (
        this.validateForm.firstname &&
        this.validateEmoji(this.validateForm.firstname)
      ) {
        this.$message({
          showClose: true,
          message: "Emoji are not allowed to Firstname",
          type: "error",
        });
        return false;
      } else if (
        this.validateForm.lastname &&
        this.validateEmoji(this.validateForm.lastname)
      ) {
        this.$message({
          showClose: true,
          message: "Emoji are not allowed to Lastname",
          type: "error",
        });
        return false;
      } else if (this.validateForm.email == this.validateForm.boss) {
        this.$message({
          showClose: true,
          message: "Not allowed to member and manager to be the same",
          type: "error",
        });
        return false;
      } else if (this.validateForm.dispmanager.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: this.validateForm.dispmanager,
          type: "error",
        });
        return false;
      }
      // else if (
      //   this.validateForm.email &&
      //   !this.validateEmail(this.validateForm.email)
      // ) {
      //   this.$message({
      //     showClose: true,
      //     message: "A valid email address is required",
      //     type: "error"
      //   });
      //   return false;
      // }
      else {
        if (this.mode == "edit") {
          this.$store
            .dispatch("newmember/updateMember", {
              id: this.id,
              form: this.validateForm,
            })
            .then(() => {
              this.dialogFormVisible = false;
              this.cancelAdd();
            });
          this.$message({
            type: "success",
            message: "Member profile has been updated",
          });
        } else {
          let ctemail = this.validateForm.email.toLowerCase();
          const newId = ctemail.replace(/\./g, "||");
          firebase
            .database()
            .ref(`/users/${newId}`)
            .once("value", (snapshot) => {
              if (snapshot.val()) {
                this.$message.error("This email has already been registered.");
              } else {
                firebase
                  .database()
                  .ref(`/users_employee_exit/${newId}`)
                  .once("value", (snapshot) => {
                    if (snapshot.val()) {
                      this.$message.error(
                        "The email is already in use (as an archived member)"
                      );
                    } else {
                      this.$store
                        .dispatch("newmember/createMember", {
                          form: this.validateForm,
                          invite: this.checkedAutoSendInvit,
                        })
                        .then(() => {
                          this.dialogFormVisible = false;
                          this.cancelAdd();
                        });
                      this.$message({
                        type: "success",
                        message: "New member has been created",
                      });
                    }
                  });
              }
            });
        }
      }
    },
    inviteMember(email) {
      this.$confirm(
        "Are you sure you want to send an invitation email?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/inviteMember", email);
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Invitation sent successfully",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Invitation email canceled",
          });
        });
    },
    inviteArrMember() {
      this.$confirm(
        "Are you sure you want to send the invitation email?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/inviteArrMember", this.checkedData);
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Invitation sent successfully",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Invitation canceled",
          });
        });
    },
    rowClickEdit(row, column, event) {
      if (column.columnKey && column.columnKey == "memberCheckbox") {
      } else {
        const item = row;
        this.id = item.key;
        this.mode = "edit";
        if (item.archiveSchedule) {
          this.scheduledArchive = true;
          this.dateArchive = format(
            new Date(item.archive_date),
            "MMM D, YYYY h:mm A"
          );
        } else {
          this.scheduledArchive = false;
        }
        if (item.introduce) this.validateForm.introduce = item.introduce;
        if (item.culture_add_percentile)
          this.validateForm.culture_add_percentile =
            item.culture_add_percentile;
        this.validateForm.large_pic = item.large_pic;
        this.validateForm.firstname = item.firstname;
        this.validateForm.lastname = item.lastname;
        this.validateForm.email = item.email;
        this.validateForm.dispteam = item.team_name;
        let colorCode = item.team_color
          ? item.team_color.replace(/#/g, "")
          : "";
        this.validateForm.team_color = colorCode;
        this.validateForm.team = item.team;
        this.validateForm.boss_team_name = item.boss_team_name;
        this.validateForm.boss = item.boss;
        this.validateForm.tmp_boss = item.boss;
        this.validateForm.boss_pic = item.boss_pic;
        this.validateForm.dispboss = item.boss_name;
        this.validateForm.boss_firstname = item.boss_firstname;
        this.validateForm.boss_lastname = item.boss_lastname;
        this.validateForm.language = item.language;
        this.validateForm.user_type = item.user_type;
        this.validateForm.country = item.country ? item.country : "TH";
        var timezone = "";
        if (item.timezone || item.timezone == 0) {
          if (item.timezone >= 0) {
            if (item.timezone < 10) {
              timezone =
                "+0" + item.timezone.toFixed(2).toString().replace(".", ":");
            } else {
              timezone =
                "+" + item.timezone.toFixed(2).toString().replace(".", ":");
            }
          } else {
            if (item.timezone < 10) {
              timezone =
                "-0" +
                item.timezone
                  .toFixed(2)
                  .toString()
                  .replace("-", "")
                  .replace(".", ":");
            } else {
              timezone = item.timezone.toFixed(2).toString().replace(".", ":");
            }
          }
        } else {
          timezone = "+07.00";
        }
        this.validateForm.time_zone = timezone;
        // this.validateForm.invite = false;
        this.validateForm.status = item.status;
        this.validateForm.to_now = item.to_now;
        this.validateForm.streak_count = item.streak_count
          ? item.streak_count
          : 0;
        this.validateForm.super_feedback_count = item.super_feedback_count
          ? item.super_feedback_count
          : 0;
        this.validateForm.medal = item.medal ? item.medal : [];
        this.validateForm.coin = item.coin;
        this.validateForm.gem = item.gem;
        this.validateForm.house = item.house;
        this.validateForm.joined = item.joined ? item.joined : "";
        this.validateForm.joined_tooltips =
          item.joined_tooltips && item.joined_tooltips.length > 0
            ? item.joined_tooltips[0]
            : [];
        if (item.order_join) {
          let joinTotal = Object.keys(this.datamembers["membersall"]).filter(
            (k) => this.datamembers["membersall"][k].order_join
          ).length;
          this.validateForm.joined_tooltips["percent"] = (
            ((joinTotal - item.order_join) / joinTotal) *
            100
          ).toFixed();
        }
        this.validateForm.dispmanager = "";
        let directReportsData = {};
        directReportsData.total = 0;
        directReportsData.directReport = [];
        let directReport = _.filter(this.datamembers["membersall"], {
          boss: item.email,
        });
        if (directReport.length > 0) {
          this.directReportsData.total = directReport.length;
          this.directReportsData.directReport = directReport;
          // this.activeProfileTab = 'directReports'
        } else {
          // this.activeProfileTab = 'information'
          this.directReportsData = directReportsData;
        }
        this.$store.dispatch("newmember/getModalMemberData", item);
        this.activeName = "powers";
        this.activeProfileTab = "information";
        this.switchToArchive = false;
        this.dialogFormVisible = true;
        this.$store.dispatch("newmember/getRisk", item);
        this.$store.dispatch("newmember/getStarPerformer", item);
        this.$store.dispatch("newmember/getHoliday", item);
        this.$store.dispatch("newmember/getPowerData", item);
        this.$store.dispatch("newmember/getDataHerepoint", item.email);
        this.$store.dispatch("newmember/getDailyStatus", item).then(() => {
          setTimeout(() => {
            var container = this.$el.querySelector("#riskBox");
            container.scrollLeft = container.scrollWidth;
          }, 1000);
        });
      }
    },
    tableRowStyle({ row, rowIndex }) {
      return "cursor: pointer;";
    },
    renderSelectedPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    cancelAssignManagerModal() {
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.assignManager = "";
      this.selectedManagerForAssign = null;
      this.manager_assign_disp = "";
    },
    cancelAssignTeamModal() {
      this.teamSuggest = [];
      this.teamSuggest_temp = [];
      this.assignTeam = "";
      this.selectedTeamForAssign = null;
      this.team_assign_disp = "";
    },
    assignTeamModalClick() {
      this.$store.commit("newmember/setTeamParentKey", []);
      this.$store.dispatch("newmember/getTeamParentKeyData", this.user);
    },
    assignManagerModalClick() {
      let memberData = this.checkedData;
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.assignManager = "";
      this.selectedManagerForAssign = null;
      for (const i in memberData) {
        if (this.managerSuggest.length < 8) {
          if (memberData[i].boss) {
            /*direc manager*/
            let bossKeyID = memberData[i].boss.replace(/\./g, "||");
            if (
              this.membersByKey[bossKeyID] &&
              this.membersByKey[bossKeyID].boss
            ) {
              let bigBossKeyID = this.membersByKey[bossKeyID].boss.replace(
                /\./g,
                "||"
              );
              if (this.membersByKey[bossKeyID].boss) {
                let chk_managerExist = _.filter(this.managerSuggest, {
                  key: bigBossKeyID,
                });
                let chk_duplicate = _.filter(memberData, { key: bigBossKeyID });
                if (chk_managerExist.length == 0 && chk_duplicate.length == 0) {
                  this.managerSuggest.push(this.membersByKey[bigBossKeyID]);
                  this.managerSuggest_temp.push(
                    this.membersByKey[bigBossKeyID]
                  );
                }
              }
            }

            /*share direct manager*/
            if (this.bossByKey[bossKeyID]) {
              let shareManager = _.filter(this.datamembers["membersall"], {
                boss: memberData[i].boss,
              });
              if (shareManager.length > 0) {
                for (const j in shareManager) {
                  if (this.managerSuggest.length < 8) {
                    if (this.bossByKey[shareManager[j].key]) {
                      let chk_managerExist = _.filter(this.managerSuggest, {
                        key: shareManager[j].key,
                      });
                      let chk_duplicate = _.filter(memberData, {
                        key: shareManager[j].key,
                      });
                      if (
                        chk_managerExist.length == 0 &&
                        chk_duplicate.length == 0
                      ) {
                        this.managerSuggest.push(
                          this.membersByKey[shareManager[j].key]
                        );
                        this.managerSuggest_temp.push(
                          this.membersByKey[shareManager[j].key]
                        );
                      }
                    }
                  } else {
                    return;
                  }
                }
              }
            }
          }
        } else {
          return;
        }
      }
    },
    assignManagerActiveClick(item, index) {
      this.selectedManagerForAssign = index;
      this.assignManager = item.email;
    },
    assignManagerModalSubmit() {
      if (!this.assignManager) {
        this.$message({
          showClose: true,
          message: "Please assign a manager",
          type: "error",
        });
        return false;
      } else {
        this.$confirm(
          "Are you sure you want to assign this manager?",
          "Confirm",
          {
            confirmButtonText: "Yes, confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$store.dispatch("newmember/assignManagerSubmit", {
              memberData: this.checkedData,
              manager: this.assignManager,
            });
            let check = this.checked;
            for (const i in check) {
              this.$set(this.checked, i, false);
            }
            this.checkedData = [];
            this.cancelAssignManagerModal();
            this.assignManagerModalStatus = false;
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Manager assignement successful",
            });
          })
          // .then(() => {
          //   this.$store.dispatch("newteam/getTeams", this.user);
          //   this.$store.dispatch("membermanager/getMemberManager", this.user);
          // })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Manager assignment canceled",
            });
          });
      }
    },
    assignTeamActiveClick(item, index) {
      this.selectedTeamForAssign = index;
      this.assignTeam = item.key;
    },
    assignTeamModalSubmit() {
      if (!this.assignTeam) {
        this.$message({
          showClose: true,
          message: "Please select a team",
          type: "error",
        });
        return false;
      } else {
        this.$confirm("Are you sure you want to select this team?", "Confirm", {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.$store.dispatch("newmember/assignTeamSubmit", {
              memberData: this.checkedData,
              team: this.assignTeam,
            });
            let check = this.checked;
            for (const i in check) {
              this.$set(this.checked, i, false);
            }
            this.checkedData = [];
            this.cancelAssignTeamModal();
            this.assignTeamModalStatus = false;
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Team successfully updated",
            });
          })
          // .then(() => {
          //   this.$store.dispatch("newteam/getTeams", this.user);
          //   this.$store.dispatch("membermanager/getMemberManager", this.user);
          // })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Team update canceled",
            });
          });
      }
    },
    archivedModalClick() {
      this.archivedModalStatus = !this.archivedModalStatus;
      this.$store.dispatch("newmember/getArchiveData", this.user);
    },
    unarchiveMemberClick(row) {
      this.$confirm(
        "Are you sure you want to unarchive this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (row.archiveSchedule) {
            this.$store.dispatch("newmember/unArchiveScheduleMember", row.key);
          } else {
            this.$store.dispatch("newmember/unArchiveMember", row.key);
          }

          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Unarchived",
          });
        })
        // .then(() => {
        //   this.$store.dispatch("newteam/getTeams", this.user);
        //   this.$store.dispatch("membermanager/getMemberManager", this.user);
        // })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancelled",
          });
        });
    },
    deleteArchiveMemberClick(id) {
      this.$confirm(
        "Are you sure you want to permanently delete this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/deleteArchiveMember", id);
          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Deleted",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    unarchiveArrMemberClick() {
      let schedule = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return currentObject.archiveSchedule;
        }
      );
      let nonSchedule = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return !currentObject.archiveSchedule;
        }
      );

      this.$confirm(
        "Are you sure you want to unarchive this member?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (nonSchedule) {
            this.$store.dispatch("newmember/unArchiveArrMember", nonSchedule);
          }
          if (schedule) {
            this.$store.dispatch(
              "newmember/unArchiveArrMemberSchedule",
              schedule
            );
          }

          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Unarchived",
          });
        })
        // .then(() => {
        //   this.$store.dispatch("newteam/getTeams", this.user);
        //   this.$store.dispatch("membermanager/getMemberManager", this.user);
        // })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    deleteArchiveArrMemberClick() {
      this.$confirm(
        "Are you sure you want to permanently delete this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch(
            "newmember/deleteArchiveArrMember",
            this.checkedDataArchive
          );
          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Member account deleted",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    deleteArchiveAllClick() {
      if (this.membersArchiveAll && this.membersArchiveAll.length > 0) {
        this.$confirm(
          "Are you sure you want to delete all archived members?",
          "Warning",
          {
            confirmButtonText: "Yes, confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$store.dispatch("newmember/deleteAllArchiveMember");
            this.cancelAdd();
            this.cancelAddArchive();
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Member accounts deleted",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Canceled",
            });
          });
      }
    },
    loadMoreData() {
      this.$store.dispatch("newmember/getDailyStatus", this.validateForm);
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      let width = (450 / 100) * percentage;
      return width || "0";
    },
    cancelSchedule() {
      this.$confirm(
        "Would you like to cancel the scheduled archive process for this member?",
        "Are you sure?",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/unArchiveScheduleMember", this.id);
          this.dialogFormVisible = false;
          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "The scheduled archive process has been canceled.",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancelled",
          });
        });
    },
    datePickerUpdateTime() {
      const date = new Date();
      let hour = date.getHours();
      let minute = date.getMinutes() + 3;
      if (minute > 60) {
        minute = "03";
        hour = hour + 1;
      }
      this.pickerOptions.selectableRange = `${hour}:${minute}:00 - 23:59:00`;
    },
    checkNowPicker() {
      this.datePickerUpdateTime();
    },
    selectArchivedType(value, type) {
      // console.log("TODO: set type =>ssss ", value);
      this.$store
        .dispatch("newmember/updateArchiveTypeMember", {
          id: value.user.key,
          type: value.type,
        })
        .then(() => {
          value.user.archive_type = value.type;
        });
    },
    handleArchivedType(value) {
      value.item.archived_type = value.type;
    },
    handleArchiveButtonClick() {
      this.$message({
        message: 'Please select a reason from the dropdown menu',
        type: 'warning',
        duration: 3000,
        showClose: false
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#tabMembers >>> .divContentProfileModal {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.text-archived {
  font-size: 14px;
  color: #747474;
  margin-right: 24px;
  text-decoration: underline;
  cursor: pointer;
}
.txtArchivedModal {
  font-size: 16px;
  color: #494949;
  text-decoration: underline;
  cursor: pointer;
  padding-bottom: 32px;
}
.cancel-achive-box {
  border-radius: 0.3rem;
  background-color: #ea183c;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  padding: 16px 30px;
  .link {
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
}
.btnAddMember {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
}
.btnAddMember:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.8;
}
.btnDeleteMember {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  height: 30px;
}
.btnDeleteMember:hover {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  opacity: 0.8;
}
.btnExportAll {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  color: #747474;
}
.btnExportAll:hover {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  color: #747474;
  opacity: 0.6;
}
.el-submenu {
  width: 220px;
}
.divActionHeader {
  margin-right: 30px;
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.viewMember {
  border: 1px solid #c4c4c4;
}
.selectionmenu .viewMember {
  border: 1px solid rgb(108, 48, 204);
}
.phase-header {
  width: 200px;
  height: 200px;
  background: #222222;
}
.el-dropdown-menu__item {
  font-size: 14px;
  font-weight: 500;
  color: #585858;
}
li.el-dropdown-menu__item:hover {
  background-color: #6c30cc;
  color: #ffffff;
}
div.el-dropdown {
  padding-left: 0px;
}
.second-column {
  background-color: #f8f8f8;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
.txtHeaderStyle {
  margin: 0px;
  padding-bottom: 8px;
  font-size: 16px;
  color: #2d2e36;
  font-weight: 700;
}
.btnArchiveModal {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  width: 155px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnArchiveModal:hover {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  opacity: 0.6;
}
.btnAddMemberModal {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnAddMemberModal:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.btnInviteMemberModal {
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnCancelArchiveModal {
  width: 122px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.bg-hover-barken-54279B {
  background-color: #54279b;
  color: #fff;
}
.bg-hover-barken-54279B:hover {
  background-color: #3f1e74;
}
.second-column-modal {
  padding: 40px;
  height: 100%;
  .btn {
    padding: 16px 32px;
    color: #fff;
    font-weight: 700;
    &:hover {
      opacity: 0.7;
    }
  }
  .secondary {
    background-color: #d1d1d1;
  }
  .primary {
    background-color: #32c2d5;
  }
  > .grid-2 {
    display: grid;
    grid-template-columns: 340px 340px;
    grid-gap: 20px;
    width: 100%;
    > .card {
      transition: 0.3s;
      padding: 24px;
      background-color: #f7f7f7;
      border: 1px solid #f7f7f7;
    }
    .active-card {
      background-color: #e8e8e8;
      border: 1px solid #c7c7c7;
    }
  }
}
.height-bind {
  margin-top: -10px;
  height: 52px;
}
.text-link {
  color: skyblue;
  cursor: pointer;
  text-decoration: underline;
}
.modal-edit-team {
  grid-template-columns: 320px auto;
  border-radius: 2px 0 0 2px;
  > .member-selected {
    width: calc(320px - (40px + 30px));
    padding: 40px;
    padding-right: 30px;
    background-color: #f8f8f8;
  }
}
.modal-2-column {
  display: grid;
  height: 100%;
}
#reAssignManagerModal {
  .first-column-modal {
    padding: 40px;
    padding-right: 30px;
    background-color: #f8f8f8;
    height: 100%;
  }
  .second-column-modal {
    padding: 40px;
    height: 100%;
  }
  .second-column-modal .btn {
    padding: 16px 32px;
    color: #fff;
    font-weight: 700;
  }
  .second-column-modal .btn:hover {
    opacity: 0.7;
  }
  .second-column-modal .secondary {
    background-color: #d1d1d1;
  }
  .second-column-modal .primary {
    background-color: #32c2d5;
  }
  .second-column-modal > .grid-2 {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 20px;
    width: 100%;
  }
  .second-column-modal > .grid-2 > .card {
    transition: 0.3s;
    padding: 24px;
    background-color: #f7f7f7;
    border: 1px solid #f7f7f7;
  }
  .second-column-modal > .grid-2 > .active-card {
    background-color: #e8e8e8;
    border: 1px solid #c7c7c7;
  }
}
.btn-archive {
  background-color: #f44336;
  height: 50px;
  border-radius: 3px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  width: 155px;
}

@keyframes memberskeleton {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.loading-member-table {
  opacity: 1;
  animation-name: memberskeleton;
  transition: 0.3s;
  animation-duration: 3s;
}
</style>
<style lang="scss">
.hide-btn-picker-time {
  .el-picker-panel__footer {
    .el-picker-panel__link-btn {
      &:first-child {
        display: none;
      }
      &:last-child {
        display: inline-block;
      }
    }
  }
}
#tabMembers .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
#tabMembers .el-checkbox__inner {
  width: 24px;
  height: 24px;
  border: 1px solid #c6c6c6;
}
#tabMembers .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #5423a2;
  border: 1px solid #5423a2;
}
#tabMembers .el-table th > .cell {
  font-weight: 700;
}
#tabMembers .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f5f5;
}
#tabMembers .el-table__row {
  cursor: pointer;
}
#tabMembers span.el-checkbox__inner::after {
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  top: 2px;
  left: 7px;
  width: 5px;
  height: 13px;
}
#tabMembers label.el-checkbox {
  line-height: 24px;
}
#tabMembers .el-checkbox__input {
  zoom: 1 !important;
}
#tabMembers .el-dialog {
  width: 1100px;
}
#archiveMember .el-dialog__header,
#tabMembers .el-dialog__header {
  padding: 0px;
}
#archiveMember {
  .el-dialog__body {
    background-color: #f8f8f8;
  }
  .btn-archive {
    background-color: #f44336;
    height: 50px;
    border-radius: 3px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    width: 360px;
    margin: auto;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 360px;
  }
}
#tabMembers .el-dialog__body {
  padding: 0px;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
#reviewUpdatesModal .el-dialog__body{
  height: auto;
  > div {
    padding: 40px 15px 40px 40px;
  }
}
#tabHeaderStyle .el-tabs__header {
  margin: 0 0 4px;
}
#tabMembers .el-table .cell {
  line-height: 20px;
}
#tabMembers .el-dialog__headerbtn {
  font-size: 26px;
}
#tabMembers .profileform .el-input__inner {
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  border: none;
  padding: 0 32px;
}
#tabMembers .profileform .el-input-group__prepend {
  border: none;
  background: #ffffff;
}
#tabMembers .profileform .managerfield .el-input__inner {
  height: 80px;
  padding: 0 16px 16px 42px;
}
#tabMembers .profileform .teamfield .el-input__inner {
  height: 60px;
  background: #e4e4e4;
  border-left-width: 7px;
  border-left-style: solid;
  /* border-left-color: #6c30cc; */
  padding: 0 32px;
}
#tabMembers .profileform .managerfield .el-input-group__prepend {
  width: 0;
  padding: 0;
}
#tabMembers .profileform .rolefield .el-input__inner,
#tabMembers .profileform .langfield .el-input__inner {
  height: 42px;
}
#tabMembers .profileform .el-input.is-disabled .el-input__inner {
  background-color: #eee;
  border-color: #eee;
  color: #888;
}
#membersContainer #tabMembers .el-tabs__item.is-active,
#membersContainer #tabMembers .el-tabs__item {
  font-size: 16px;
  height: 44px;
}
#membersContainer #tabMembers #modal_profile .el-tabs__item {
  width: 200px;
}
#tabMembers .profileform .border-left-color- .el-input__inner {
  border-left-color: #747474;
}
#tabMembers .el-table td {
  padding: 12px 0;
}
#tabMembers .profileform .border-left-color-6C30CC .el-input__inner {
  border-left-color: #6c30cc;
}
#tabMembers .profileform .border-left-color-4F86C6 .el-input__inner {
  border-left-color: #4f86c6;
}
#tabMembers .profileform .border-left-color-50B0C6 .el-input__inner {
  border-left-color: #50b0c6;
}
#tabMembers .profileform .border-left-color-379392 .el-input__inner {
  border-left-color: #379392;
}
#tabMembers .profileform .border-left-color-68D5B5 .el-input__inner {
  border-left-color: #68d5b5;
}
#tabMembers .profileform .border-left-color-EE7885 .el-input__inner {
  border-left-color: #ee7885;
}
#tabMembers .profileform .border-left-color-C99EC4 .el-input__inner {
  border-left-color: #c99ec4;
}
#tabMembers .profileform .border-left-color-84B1ED .el-input__inner {
  border-left-color: #84b1ed;
}
#tabMembers .profileform .border-left-color-31AADE .el-input__inner {
  border-left-color: #31aade;
}
#tabMembers .profileform .border-left-color-F0DC05 .el-input__inner {
  border-left-color: #f0dc05;
}
#tabMembers .profileform .border-left-color-E63A40 .el-input__inner {
  border-left-color: #e63a40;
}
#archivedModal .el-dialog__body {
  min-height: 880px;
  height: auto;
}
#tabMembers .send-style {
  span.el-checkbox__inner::after {
    left: 5px;
    top: 0px;
    width: 3px;
    height: 9px;
  }
  .el-checkbox__inner {
    width: 18px;
    height: 18px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #32c2d5;
    border: 1px solid #32c2d5;
  }
  .el-checkbox__input + .el-checkbox__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2d2e36;
    font-size: 13px;
    font-weight: 400;
  }
}

.happily-primary.el-badge-unread > .el-badge__content {
  background-color: #E45006;
  line-height: 14px;
  height: 14px;
  min-width: 14px;
  padding: 4px;
  margin: 0;
  border-radius: 50%;
}

#reviewUpdatesTable.el-table td:last-child .cell {
  position: relative;
  top: 6px;
}
.requested_by {
  display: inline-block;
  width: 120px;
  text-align: left;
  line-height: 12px;
  padding-top: 4px;
}
</style>
